/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bootstrap = __webpack_require__(1);
	
	var _bootstrap2 = _interopRequireDefault(_bootstrap);
	
	var _ScrollTo = __webpack_require__(2);
	
	var _Resize = __webpack_require__(3);
	
	var _Resize2 = _interopRequireDefault(_Resize);
	
	var _DistributeHeight = __webpack_require__(5);
	
	var _DistributeHeight2 = _interopRequireDefault(_DistributeHeight);
	
	var _SearchBox = __webpack_require__(6);
	
	var _FunctionGuide = __webpack_require__(7);
	
	var _Usertemplate = __webpack_require__(8);
	
	var _Slider = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*import {Fancybox} from './Utilities/Fancybox';*/
	
	/* Theme imports */
	/* eg. import tooltip from './Theme/Tooltip'; */
	/* Bootstrap imports */
	var functionGuide = new _FunctionGuide.FunctionGuide();
	
	/* Module imports */
	
	
	/* Utilities imports */
	
	functionGuide.setHeight();
	functionGuide.initEventHandlers();
	functionGuide.historyPopstate();
	
	document.querySelectorAll('[data-role="text-slider"]').forEach(function (element) {
	    element.slider = new _Slider.Slider(element);
	});
	
	/* Renders */
	window.scrollto = new _ScrollTo.ScrollTo();
	var resizeFunction = new _Resize2.default(functionGuide);
	new _SearchBox.SearchBox();
	new _Usertemplate.Usertemplate();
	
	resizeFunction.resize();
	
	var distributeHeight = new _DistributeHeight2.default();
	$('.panel-collapse').on('hidden.bs.collapse', function () {
	    distributeHeight.setHeights();
	});
	
	$('.panel-collapse').on('shown.bs.collapse', function () {
	    distributeHeight.setHeights();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScrollTo = exports.ScrollTo = function () {
	  function ScrollTo() {
	    _classCallCheck(this, ScrollTo);
	
	    this.events();
	  }
	
	  _createClass(ScrollTo, [{
	    key: 'events',
	    value: function events() {
	      $(document).on('click', '[data-scroll]', $.proxy(this.scrollTo, this));
	    }
	  }, {
	    key: 'scrollTo',
	    value: function scrollTo(event) {
	      var $anchor = $(event.currentTarget);
	      var target = $anchor.attr('href');
	      var offset = 0;
	
	      // If there is a custom offset
	      if ($anchor.data('offset')) {
	        offset = $anchor.data('offset');
	      }
	
	      /* check if we have an url, and if it is on the current page and the element exists disabled for nav-tabs */
	      if ($(target).length > 0) {
	        var $htmlBody = $('html, body');
	        $htmlBody.stop();
	        $htmlBody.animate({
	          scrollTop: $(target).offset().top - offset
	        }, 500);
	      }
	    }
	  }]);

	  return ScrollTo;
	}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _requestanimationframe = __webpack_require__(4);
	
	var _requestanimationframe2 = _interopRequireDefault(_requestanimationframe);
	
	var _DistributeHeight = __webpack_require__(5);
	
	var _DistributeHeight2 = _interopRequireDefault(_DistributeHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var distributeHeight = new _DistributeHeight2.default();
	
	var _class = function () {
	  function _class(functionGuide) {
	    _classCallCheck(this, _class);
	
	    this.functionGuide = functionGuide;
	    this.windowWidth = $(window).width();
	  }
	
	  _createClass(_class, [{
	    key: 'resize',
	    value: function resize() {
	      var _this = this;
	
	      var calculate = void 0,
	          tick = void 0,
	          ticking = false;
	
	      calculate = function calculate() {
	        distributeHeight.setHeights();
	        _this.functionGuide.setHeight();
	        _this.functionGuide.movePanels();
	
	        if (_this.windowWidth != $(window).width()) {
	          _this.functionGuide.closeAllPanelsOnMobile();
	        }
	        ticking = false;
	      };
	
	      tick = function tick() {
	        if (!ticking) {
	          (0, _requestanimationframe2.default)(calculate);
	          ticking = true;
	        }
	      };
	      tick();
	
	      $(window).on('load resize', function () {
	        tick();
	      });
	    }
	  }]);

	  return _class;
	}();

	exports.default = _class;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * requestAnimationFrame version: "0.0.23" Copyright (c) 2011-2012, Cyril Agosta ( cyril.agosta.dev@gmail.com) All Rights Reserved.
	 * Available via the MIT license.
	 * see: http://github.com/cagosta/requestAnimationFrame for details
	 *
	 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
	 * MIT license
	 *
	 */
	
	
	( function( global ) {
	
	
	    ( function() {
	
	
	        if ( global.requestAnimationFrame ) {
	
	            return;
	
	        }
	
	        if ( global.webkitRequestAnimationFrame ) { // Chrome <= 23, Safari <= 6.1, Blackberry 10
	
	            global.requestAnimationFrame = global[ 'webkitRequestAnimationFrame' ];
	            global.cancelAnimationFrame = global[ 'webkitCancelAnimationFrame' ] || global[ 'webkitCancelRequestAnimationFrame' ];
	            return;
	
	        }
	
	        // IE <= 9, Android <= 4.3, very old/rare browsers
	
	        var lastTime = 0;
	
	        global.requestAnimationFrame = function( callback ) {
	
	            var currTime = new Date().getTime();
	
	            var timeToCall = Math.max( 0, 16 - ( currTime - lastTime ) );
	
	            var id = global.setTimeout( function() {
	
	                callback( currTime + timeToCall );
	
	            }, timeToCall );
	
	            lastTime = currTime + timeToCall;
	
	            return id; // return the id for cancellation capabilities
	
	        };
	
	        global.cancelAnimationFrame = function( id ) {
	
	            clearTimeout( id );
	
	        };
	
	    } )();
	
	    if ( true ) {
	
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	            return global.requestAnimationFrame;
	
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	    }
	
	} )( window );

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	  function _class() {
	    _classCallCheck(this, _class);
	  }
	
	  _createClass(_class, [{
	    key: 'setHeights',
	    value: function setHeights() {
	      // Variables
	      var $wrap = void 0,
	          $this = void 0,
	          $item = void 0,
	          $items = void 0,
	          key = void 0,
	          keys = void 0,
	          height = void 0,
	          maxHeights = void 0;
	
	      // The wrap
	      $wrap = $('[data-distribute-height]');
	
	      // Calculate the heights of the items grouped per wrap
	      $wrap.each(function () {
	        $this = $(this);
	        $items = $this.find('[data-mh]');
	        maxHeights = [];
	
	        // Reset all heights, so we can recalculate them
	        $items.height('auto');
	
	        if ($(window).width() < 768 && $this.data('limit') == 'mobile') {
	          return;
	        }
	        if ($(window).width() < 992 && $this.data('limit') == 'tablet') {
	          return;
	        }
	
	        // Check each item in the wrap
	        $items.each(function () {
	          $item = $(this);
	          key = $item.data('mh');
	          height = $item.height();
	
	          // First, set the max-height for each type to zero (if it doesn't exist yet)
	          if (!maxHeights.hasOwnProperty(key)) maxHeights[key] = 0;
	
	          // Check the height of the item, if it's higher than the previous one, overwrite the maxHeight for that type of item
	          if (height >= maxHeights[key]) maxHeights[key] = height;
	        });
	
	        // Set the height of the same types of items
	        keys = Object.keys(maxHeights);
	        for (var i = 0; i < keys.length; i++) {
	          key = keys[i];
	          $this.find('[data-mh=' + key + ']').height(maxHeights[key]);
	        }
	      });
	    }
	  }]);

	  return _class;
	}();

	exports.default = _class;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchBox = exports.SearchBox = function () {
	  function SearchBox() {
	    _classCallCheck(this, SearchBox);
	
	    $('[data-action="open-search-box"]').on('click', $.proxy(this.openSearchBox, this));
	  }
	
	  _createClass(SearchBox, [{
	    key: 'openSearchBox',
	    value: function openSearchBox() {
	      $('[data-role="search-box"]').addClass('open');
	      $('input[name=q_widget]').focus();
	    }
	  }]);

	  return SearchBox;
	}();

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FunctionGuide = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _DistributeHeight = __webpack_require__(5);
	
	var _DistributeHeight2 = _interopRequireDefault(_DistributeHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var distributeHeight = new _DistributeHeight2.default();
	
	var FunctionGuide = exports.FunctionGuide = function () {
	  function FunctionGuide() {
	    _classCallCheck(this, FunctionGuide);
	
	    this.functionGuide = $('[data-init="function-guide"]');
	    this.scrollOffset = false;
	    this.activePanelIndex = 0;
	    this.maxPanelIndex = 5;
	    this.panelOpened = false;
	  }
	
	  _createClass(FunctionGuide, [{
	    key: 'historyPopstate',
	    value: function historyPopstate() {
	      if (window.location.hash && $('.function-sectors').length > 0) {
	        var id = window.location.hash.substr(1);
	        this.activePanelIndex = $('[data-id="' + id + '"]').index() / 2;
	        this.expandPanel();
	      }
	    }
	  }, {
	    key: 'initEventHandlers',
	    value: function initEventHandlers() {
	      $('[data-toggle="function-panel"]').on('click', $.proxy(this.togglePanelClickHandler, this));
	      $('[data-role="function-guide-navigation"]').on('click', $.proxy(this.functionNavigationHandler, this));
	      $('[data-role="sector-navigation"]').on('click', $.proxy(this.sectorNavigationHandler, this));
	    }
	  }, {
	    key: 'setHeight',
	    value: function setHeight() {
	      if ($(window).width() < 768) {
	        this.functionGuide.css('min-height', 'auto');
	        this.functionGuide.children('div').css('min-height', 'auto');
	        return;
	      }
	
	      var height = $(window).height() - $('#footer').height() - $('.navbar').height();
	      this.functionGuide.css('min-height', height);
	      this.functionGuide.children('div').css('min-height', height);
	      distributeHeight.setHeights();
	    }
	  }, {
	    key: 'togglePanelClickHandler',
	    value: function togglePanelClickHandler(e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);
	      this.activePanelIndex = $this.parents('.function-sector').index() / 2;
	      this.expandPanel();
	    }
	  }, {
	    key: 'expandPanel',
	    value: function expandPanel() {
	      var $sectorPanel = $('.function-sector:eq(' + this.activePanelIndex + ')');
	      var $panel = $sectorPanel.next('.function-sector-panel');
	      var itemCount = 3;
	      var offset = 0;
	
	      if ($(window).width() < 768) {
	        $panel.slideToggle();
	        distributeHeight.setHeights();
	      }
	
	      if ($panel.hasClass('active')) {
	        $sectorPanel.removeClass('active');
	        $panel.removeClass('active');
	        history.pushState(null, null, '#');
	
	        if (this.scrollOffset && $(window).width() < 992) {
	          offset = -$(window).width() / itemCount * 3;
	        }
	
	        // Reset the position of all items
	        if (this.scrollOffset && $(window).width() < 992) {
	          this.activePanelIndex = 3;
	        } else {
	          this.activePanelIndex = 0;
	        }
	
	        this.panelOpened = false;
	        this.setPanelOffset(offset);
	        this.setTitles();
	        return;
	      }
	      // Close all panels
	      $('.function-sector').removeClass('active');
	      $('.function-sector-panel').removeClass('active');
	
	      // Activate the selected panel
	      $sectorPanel.addClass('active');
	      $panel.addClass('active');
	      history.pushState(null, null, '#' + $sectorPanel.data('id'));
	
	      this.panelOpened = true;
	
	      if ($(window).width() >= 768) {
	        this.movePanels();
	        this.setTitles();
	      }
	    }
	  }, {
	    key: 'closeAllPanels',
	    value: function closeAllPanels() {
	      $('.function-sector').removeClass('active');
	      $('.function-sector-panel').removeClass('active');
	    }
	  }, {
	    key: 'closeAllPanelsOnMobile',
	    value: function closeAllPanelsOnMobile() {
	      if ($(window).width() < 768) {
	        this.panelOpened = false;
	        $('.function-sector-panel').css('display', 'none');
	        $('.function-sector').removeClass('active');
	        $('.function-sector-panel').removeClass('active');
	      } else {
	        $('.function-sector-panel').css('display', 'block');
	      }
	    }
	  }, {
	    key: 'movePanels',
	    value: function movePanels() {
	      var itemCount = 6;
	      var index = this.activePanelIndex;
	
	      if ($(window).width() < 992) {
	        itemCount = 3;
	
	        if (this.scrollOffset && !this.panelOpened) {
	          index = 3;
	        }
	      }
	
	      if ($(window).width() >= 992 && !this.panelOpened) {
	        index = 0;
	      }
	
	      var offset = -$(window).width() / itemCount * index;
	      this.setPanelOffset(offset);
	    }
	  }, {
	    key: 'setPanelOffset',
	    value: function setPanelOffset(offset) {
	      offset = offset + 'px';
	
	      if ($(window).width() < 768) {
	        offset = 0;
	      }
	
	      this.functionGuide.children().css({
	        'transform': 'translateX(' + offset + ')'
	      });
	    }
	  }, {
	    key: 'functionNavigationHandler',
	    value: function functionNavigationHandler(e) {
	      e.preventDefault();
	      $('.function-guide-pager-item').removeClass('active');
	      $(e.currentTarget).addClass('active');
	
	      var direction = $(e.currentTarget).data('direction');
	      var itemCount = 3;
	      var offset = '';
	
	      if (direction === 'previous' && !this.scrollOffset || direction === 'next' && this.scrollOffset) {
	        return;
	      }
	
	      if (direction === 'previous' && this.scrollOffset) {
	        this.scrollOffset = false;
	        offset = 0;
	      } else if (direction === 'next' && !this.scrollOffset) {
	        this.scrollOffset = true;
	        offset = -$(window).width() / itemCount * 3;
	      }
	
	      this.closeAllPanels();
	      this.setPanelOffset(offset);
	    }
	  }, {
	    key: 'sectorNavigationHandler',
	    value: function sectorNavigationHandler(e) {
	      e.preventDefault();
	      var $this = $(e.currentTarget);
	      var direction = $this.data('direction');
	
	      if (direction === 'previous') {
	
	        if (this.activePanelIndex === 0) {
	          this.activePanelIndex = this.maxPanelIndex;
	        } else {
	          this.activePanelIndex--;
	        }
	      } else {
	
	        if (this.activePanelIndex === this.maxPanelIndex) {
	          this.activePanelIndex = 0;
	        } else {
	          this.activePanelIndex++;
	        }
	      }
	
	      this.expandPanel();
	    }
	  }, {
	    key: 'setTitles',
	    value: function setTitles() {
	      var previousIndex = this.activePanelIndex - 1;
	      var nextIndex = this.activePanelIndex + 1;
	
	      if (previousIndex === -1) {
	        previousIndex = this.maxPanelIndex;
	      }
	
	      if (nextIndex > this.maxPanelIndex) {
	        nextIndex = 0;
	      }
	
	      var previousTitle = $('.function-sector:eq(' + previousIndex + ')').find('.sector-title').text();
	      var currentTitle = $('.function-sector:eq(' + this.activePanelIndex + ')').find('.sector-title').text();
	      var nextTitle = $('.function-sector:eq(' + nextIndex + ')').find('.sector-title').text();
	
	      if (!this.panelOpened) {
	        currentTitle = '';
	      }
	
	      $('.current-sector').text(currentTitle);
	
	      $('.sector-pager').find('.previous-sector .pager-label').text(previousTitle);
	      $('.sector-pager').find('.next-sector .pager-label').text(nextTitle);
	    }
	  }]);

	  return FunctionGuide;
	}();

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Usertemplate = exports.Usertemplate = function () {
	  function Usertemplate() {
	    _classCallCheck(this, Usertemplate);
	
	    this.usertemplateWithoutLinkText();
	  }
	
	  _createClass(Usertemplate, [{
	    key: 'usertemplateWithoutLinkText',
	    value: function usertemplateWithoutLinkText() {
	      var items = $('[data-no-link="div"]');
	      items.each(function (index, item) {
	
	        if ($(item).find('.link-arrow [data-ft-type="text"]').html() === '') {
	          $(item).find('.icon-arrow-right').css('opacity', '0');
	        }
	      });
	    }
	  }]);

	  return Usertemplate;
	}();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Slider = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _splide = __webpack_require__(10);
	
	var _splide2 = _interopRequireDefault(_splide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Slider = exports.Slider = function () {
	    function Slider(element) {
	        _classCallCheck(this, Slider);
	
	        this.element = element;
	        // remove empty slides from user template
	        document.querySelectorAll('[data-role="slider-item"]').forEach(function (item) {
	            if (item.firstElementChild.childNodes.length === 0) item.remove();
	        });
	        this.initSlider();
	    }
	
	    _createClass(Slider, [{
	        key: 'initSlider',
	        value: function initSlider() {
	            new _splide2.default(this.element, {
	                type: 'loop',
	                autoplay: true,
	                pagination: false,
	                keyboard: true
	            }).mount();
	        }
	    }]);

	    return Slider;
	}();

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*!
	 * Splide.js
	 * Version  : 4.0.7
	 * License  : MIT
	 * Copyright: 2022 Naotoshi Fujita
	 */
	'use strict';
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
	var CREATED = 1;
	var MOUNTED = 2;
	var IDLE = 3;
	var MOVING = 4;
	var SCROLLING = 5;
	var DRAGGING = 6;
	var DESTROYED = 7;
	var STATES = {
	  CREATED: CREATED,
	  MOUNTED: MOUNTED,
	  IDLE: IDLE,
	  MOVING: MOVING,
	  SCROLLING: SCROLLING,
	  DRAGGING: DRAGGING,
	  DESTROYED: DESTROYED
	};
	
	function empty(array) {
	  array.length = 0;
	}
	
	function slice(arrayLike, start, end) {
	  return Array.prototype.slice.call(arrayLike, start, end);
	}
	
	function apply(func) {
	  return func.bind.apply(func, [null].concat(slice(arguments, 1)));
	}
	
	var nextTick = setTimeout;
	
	var noop = function noop() {};
	
	function raf(func) {
	  return requestAnimationFrame(func);
	}
	
	function typeOf(type, subject) {
	  return typeof subject === type;
	}
	
	function isObject(subject) {
	  return !isNull(subject) && typeOf("object", subject);
	}
	
	var isArray = Array.isArray;
	var isFunction = apply(typeOf, "function");
	var isString = apply(typeOf, "string");
	var isUndefined = apply(typeOf, "undefined");
	
	function isNull(subject) {
	  return subject === null;
	}
	
	function isHTMLElement(subject) {
	  return subject instanceof HTMLElement;
	}
	
	function toArray(value) {
	  return isArray(value) ? value : [value];
	}
	
	function forEach(values, iteratee) {
	  toArray(values).forEach(iteratee);
	}
	
	function includes(array, value) {
	  return array.indexOf(value) > -1;
	}
	
	function push(array, items) {
	  array.push.apply(array, toArray(items));
	  return array;
	}
	
	function toggleClass(elm, classes, add) {
	  if (elm) {
	    forEach(classes, function (name) {
	      if (name) {
	        elm.classList[add ? "add" : "remove"](name);
	      }
	    });
	  }
	}
	
	function addClass(elm, classes) {
	  toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
	}
	
	function append(parent, children) {
	  forEach(children, parent.appendChild.bind(parent));
	}
	
	function before(nodes, ref) {
	  forEach(nodes, function (node) {
	    var parent = (ref || node).parentNode;
	
	    if (parent) {
	      parent.insertBefore(node, ref);
	    }
	  });
	}
	
	function matches(elm, selector) {
	  return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
	}
	
	function children(parent, selector) {
	  var children2 = parent ? slice(parent.children) : [];
	  return selector ? children2.filter(function (child) {
	    return matches(child, selector);
	  }) : children2;
	}
	
	function child(parent, selector) {
	  return selector ? children(parent, selector)[0] : parent.firstElementChild;
	}
	
	var ownKeys = Object.keys;
	
	function forOwn(object, iteratee, right) {
	  if (object) {
	    var keys = ownKeys(object);
	    keys = right ? keys.reverse() : keys;
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	
	      if (key !== "__proto__") {
	        if (iteratee(object[key], key) === false) {
	          break;
	        }
	      }
	    }
	  }
	
	  return object;
	}
	
	function assign(object) {
	  slice(arguments, 1).forEach(function (source) {
	    forOwn(source, function (value, key) {
	      object[key] = source[key];
	    });
	  });
	  return object;
	}
	
	function merge(object) {
	  slice(arguments, 1).forEach(function (source) {
	    forOwn(source, function (value, key) {
	      if (isArray(value)) {
	        object[key] = value.slice();
	      } else if (isObject(value)) {
	        object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
	      } else {
	        object[key] = value;
	      }
	    });
	  });
	  return object;
	}
	
	function omit(object, keys) {
	  toArray(keys || ownKeys(object)).forEach(function (key) {
	    delete object[key];
	  });
	}
	
	function removeAttribute(elms, attrs) {
	  forEach(elms, function (elm) {
	    forEach(attrs, function (attr) {
	      elm && elm.removeAttribute(attr);
	    });
	  });
	}
	
	function setAttribute(elms, attrs, value) {
	  if (isObject(attrs)) {
	    forOwn(attrs, function (value2, name) {
	      setAttribute(elms, name, value2);
	    });
	  } else {
	    forEach(elms, function (elm) {
	      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
	    });
	  }
	}
	
	function create(tag, attrs, parent) {
	  var elm = document.createElement(tag);
	
	  if (attrs) {
	    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
	  }
	
	  parent && append(parent, elm);
	  return elm;
	}
	
	function style(elm, prop, value) {
	  if (isUndefined(value)) {
	    return getComputedStyle(elm)[prop];
	  }
	
	  if (!isNull(value)) {
	    elm.style[prop] = "" + value;
	  }
	}
	
	function display(elm, display2) {
	  style(elm, "display", display2);
	}
	
	function focus(elm) {
	  elm["setActive"] && elm["setActive"]() || elm.focus({
	    preventScroll: true
	  });
	}
	
	function getAttribute(elm, attr) {
	  return elm.getAttribute(attr);
	}
	
	function hasClass(elm, className) {
	  return elm && elm.classList.contains(className);
	}
	
	function rect(target) {
	  return target.getBoundingClientRect();
	}
	
	function remove(nodes) {
	  forEach(nodes, function (node) {
	    if (node && node.parentNode) {
	      node.parentNode.removeChild(node);
	    }
	  });
	}
	
	function parseHtml(html) {
	  return child(new DOMParser().parseFromString(html, "text/html").body);
	}
	
	function prevent(e, stopPropagation) {
	  e.preventDefault();
	
	  if (stopPropagation) {
	    e.stopPropagation();
	    e.stopImmediatePropagation();
	  }
	}
	
	function query(parent, selector) {
	  return parent && parent.querySelector(selector);
	}
	
	function queryAll(parent, selector) {
	  return selector ? slice(parent.querySelectorAll(selector)) : [];
	}
	
	function removeClass(elm, classes) {
	  toggleClass(elm, classes, false);
	}
	
	function timeOf(e) {
	  return e.timeStamp;
	}
	
	function unit(value) {
	  return isString(value) ? value : value ? value + "px" : "";
	}
	
	var PROJECT_CODE = "splide";
	var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
	
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
	  }
	}
	
	var min = Math.min,
	    max = Math.max,
	    floor = Math.floor,
	    ceil = Math.ceil,
	    abs = Math.abs;
	
	function approximatelyEqual(x, y, epsilon) {
	  return abs(x - y) < epsilon;
	}
	
	function between(number, minOrMax, maxOrMin, exclusive) {
	  var minimum = min(minOrMax, maxOrMin);
	  var maximum = max(minOrMax, maxOrMin);
	  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
	}
	
	function clamp(number, x, y) {
	  var minimum = min(x, y);
	  var maximum = max(x, y);
	  return min(max(minimum, number), maximum);
	}
	
	function sign(x) {
	  return +(x > 0) - +(x < 0);
	}
	
	function camelToKebab(string) {
	  return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
	}
	
	function format(string, replacements) {
	  forEach(replacements, function (replacement) {
	    string = string.replace("%s", "" + replacement);
	  });
	  return string;
	}
	
	function pad(number) {
	  return number < 10 ? "0" + number : "" + number;
	}
	
	var ids = {};
	
	function uniqueId(prefix) {
	  return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
	}
	
	function EventBinder() {
	  var listeners = [];
	
	  function bind(targets, events, callback, options) {
	    forEachEvent(targets, events, function (target, event, namespace) {
	      var isEventTarget = ("addEventListener" in target);
	      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
	      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
	      listeners.push([target, event, namespace, callback, remover]);
	    });
	  }
	
	  function unbind(targets, events, callback) {
	    forEachEvent(targets, events, function (target, event, namespace) {
	      listeners = listeners.filter(function (listener) {
	        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
	          listener[4]();
	          return false;
	        }
	
	        return true;
	      });
	    });
	  }
	
	  function dispatch(target, type, detail) {
	    var e;
	    var bubbles = true;
	
	    if (typeof CustomEvent === "function") {
	      e = new CustomEvent(type, {
	        bubbles: bubbles,
	        detail: detail
	      });
	    } else {
	      e = document.createEvent("CustomEvent");
	      e.initCustomEvent(type, bubbles, false, detail);
	    }
	
	    target.dispatchEvent(e);
	    return e;
	  }
	
	  function forEachEvent(targets, events, iteratee) {
	    forEach(targets, function (target) {
	      target && forEach(events, function (events2) {
	        events2.split(" ").forEach(function (eventNS) {
	          var fragment = eventNS.split(".");
	          iteratee(target, fragment[0], fragment[1]);
	        });
	      });
	    });
	  }
	
	  function destroy() {
	    listeners.forEach(function (data) {
	      data[4]();
	    });
	    empty(listeners);
	  }
	
	  return {
	    bind: bind,
	    unbind: unbind,
	    dispatch: dispatch,
	    destroy: destroy
	  };
	}
	
	var EVENT_MOUNTED = "mounted";
	var EVENT_READY = "ready";
	var EVENT_MOVE = "move";
	var EVENT_MOVED = "moved";
	var EVENT_SHIFTED = "shifted";
	var EVENT_CLICK = "click";
	var EVENT_ACTIVE = "active";
	var EVENT_INACTIVE = "inactive";
	var EVENT_VISIBLE = "visible";
	var EVENT_HIDDEN = "hidden";
	var EVENT_SLIDE_KEYDOWN = "slide:keydown";
	var EVENT_REFRESH = "refresh";
	var EVENT_UPDATED = "updated";
	var EVENT_RESIZE = "resize";
	var EVENT_RESIZED = "resized";
	var EVENT_DRAG = "drag";
	var EVENT_DRAGGING = "dragging";
	var EVENT_DRAGGED = "dragged";
	var EVENT_SCROLL = "scroll";
	var EVENT_SCROLLED = "scrolled";
	var EVENT_DESTROY = "destroy";
	var EVENT_ARROWS_MOUNTED = "arrows:mounted";
	var EVENT_ARROWS_UPDATED = "arrows:updated";
	var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
	var EVENT_PAGINATION_UPDATED = "pagination:updated";
	var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
	var EVENT_AUTOPLAY_PLAY = "autoplay:play";
	var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
	var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
	var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
	
	function EventInterface(Splide2) {
	  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
	  var binder = EventBinder();
	
	  function on(events, callback) {
	    binder.bind(bus, toArray(events).join(" "), function (e) {
	      callback.apply(callback, isArray(e.detail) ? e.detail : []);
	    });
	  }
	
	  function emit(event) {
	    binder.dispatch(bus, event, slice(arguments, 1));
	  }
	
	  if (Splide2) {
	    Splide2.event.on(EVENT_DESTROY, binder.destroy);
	  }
	
	  return assign(binder, {
	    bus: bus,
	    on: on,
	    off: apply(binder.unbind, bus),
	    emit: emit
	  });
	}
	
	function RequestInterval(interval, onInterval, onUpdate, limit) {
	  var now = Date.now;
	  var startTime;
	  var rate = 0;
	  var id;
	  var paused = true;
	  var count = 0;
	
	  function update() {
	    if (!paused) {
	      rate = interval ? min((now() - startTime) / interval, 1) : 1;
	      onUpdate && onUpdate(rate);
	
	      if (rate >= 1) {
	        onInterval();
	        startTime = now();
	
	        if (limit && ++count >= limit) {
	          return pause();
	        }
	      }
	
	      raf(update);
	    }
	  }
	
	  function start(resume) {
	    !resume && cancel();
	    startTime = now() - (resume ? rate * interval : 0);
	    paused = false;
	    raf(update);
	  }
	
	  function pause() {
	    paused = true;
	  }
	
	  function rewind() {
	    startTime = now();
	    rate = 0;
	
	    if (onUpdate) {
	      onUpdate(rate);
	    }
	  }
	
	  function cancel() {
	    id && cancelAnimationFrame(id);
	    rate = 0;
	    id = 0;
	    paused = true;
	  }
	
	  function set(time) {
	    interval = time;
	  }
	
	  function isPaused() {
	    return paused;
	  }
	
	  return {
	    start: start,
	    rewind: rewind,
	    pause: pause,
	    cancel: cancel,
	    set: set,
	    isPaused: isPaused
	  };
	}
	
	function State(initialState) {
	  var state = initialState;
	
	  function set(value) {
	    state = value;
	  }
	
	  function is(states) {
	    return includes(toArray(states), state);
	  }
	
	  return {
	    set: set,
	    is: is
	  };
	}
	
	function Throttle(func, duration) {
	  var interval;
	
	  function throttled() {
	    if (!interval) {
	      interval = RequestInterval(duration || 0, function () {
	        func();
	        interval = null;
	      }, null, 1);
	      interval.start();
	    }
	  }
	
	  return throttled;
	}
	
	function Media(Splide2, Components2, options) {
	  var state = Splide2.state;
	  var breakpoints = options.breakpoints || {};
	  var reducedMotion = options.reducedMotion || {};
	  var binder = EventBinder();
	  var queries = [];
	
	  function setup() {
	    var isMin = options.mediaQuery === "min";
	    ownKeys(breakpoints).sort(function (n, m) {
	      return isMin ? +n - +m : +m - +n;
	    }).forEach(function (key) {
	      register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
	    });
	    register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
	    update();
	  }
	
	  function destroy(completely) {
	    if (completely) {
	      binder.destroy();
	    }
	  }
	
	  function register(options2, query) {
	    var queryList = matchMedia(query);
	    binder.bind(queryList, "change", update);
	    queries.push([options2, queryList]);
	  }
	
	  function update() {
	    var destroyed = state.is(DESTROYED);
	    var direction = options.direction;
	    var merged = queries.reduce(function (merged2, entry) {
	      return merge(merged2, entry[1].matches ? entry[0] : {});
	    }, {});
	    omit(options);
	    set(merged);
	
	    if (options.destroy) {
	      Splide2.destroy(options.destroy === "completely");
	    } else if (destroyed) {
	      destroy(true);
	      Splide2.mount();
	    } else {
	      direction !== options.direction && Splide2.refresh();
	    }
	  }
	
	  function reduce(enable) {
	    if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
	      enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
	    }
	  }
	
	  function set(opts, user) {
	    merge(options, opts);
	    user && merge(Object.getPrototypeOf(options), opts);
	
	    if (!state.is(CREATED)) {
	      Splide2.emit(EVENT_UPDATED, options);
	    }
	  }
	
	  return {
	    setup: setup,
	    destroy: destroy,
	    reduce: reduce,
	    set: set
	  };
	}
	
	var ARROW = "Arrow";
	var ARROW_LEFT = ARROW + "Left";
	var ARROW_RIGHT = ARROW + "Right";
	var ARROW_UP = ARROW + "Up";
	var ARROW_DOWN = ARROW + "Down";
	var LTR = "ltr";
	var RTL = "rtl";
	var TTB = "ttb";
	var ORIENTATION_MAP = {
	  width: ["height"],
	  left: ["top", "right"],
	  right: ["bottom", "left"],
	  x: ["y"],
	  X: ["Y"],
	  Y: ["X"],
	  ArrowLeft: [ARROW_UP, ARROW_RIGHT],
	  ArrowRight: [ARROW_DOWN, ARROW_LEFT]
	};
	
	function Direction(Splide2, Components2, options) {
	  function resolve(prop, axisOnly, direction) {
	    direction = direction || options.direction;
	    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
	    return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function (match, offset) {
	      var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
	      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
	    });
	  }
	
	  function orient(value) {
	    return value * (options.direction === RTL ? 1 : -1);
	  }
	
	  return {
	    resolve: resolve,
	    orient: orient
	  };
	}
	
	var ROLE = "role";
	var TAB_INDEX = "tabindex";
	var DISABLED = "disabled";
	var ARIA_PREFIX = "aria-";
	var ARIA_CONTROLS = ARIA_PREFIX + "controls";
	var ARIA_CURRENT = ARIA_PREFIX + "current";
	var ARIA_SELECTED = ARIA_PREFIX + "selected";
	var ARIA_LABEL = ARIA_PREFIX + "label";
	var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
	var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
	var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
	var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
	var ARIA_LIVE = ARIA_PREFIX + "live";
	var ARIA_BUSY = ARIA_PREFIX + "busy";
	var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
	var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
	var CLASS_ROOT = PROJECT_CODE;
	var CLASS_TRACK = PROJECT_CODE + "__track";
	var CLASS_LIST = PROJECT_CODE + "__list";
	var CLASS_SLIDE = PROJECT_CODE + "__slide";
	var CLASS_CLONE = CLASS_SLIDE + "--clone";
	var CLASS_CONTAINER = CLASS_SLIDE + "__container";
	var CLASS_ARROWS = PROJECT_CODE + "__arrows";
	var CLASS_ARROW = PROJECT_CODE + "__arrow";
	var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
	var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
	var CLASS_PAGINATION = PROJECT_CODE + "__pagination";
	var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
	var CLASS_PROGRESS = PROJECT_CODE + "__progress";
	var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
	var CLASS_TOGGLE = PROJECT_CODE + "__toggle";
	var CLASS_TOGGLE_PLAY = CLASS_TOGGLE + "__play";
	var CLASS_TOGGLE_PAUSE = CLASS_TOGGLE + "__pause";
	var CLASS_SPINNER = PROJECT_CODE + "__spinner";
	var CLASS_SR = PROJECT_CODE + "__sr";
	var CLASS_INITIALIZED = "is-initialized";
	var CLASS_ACTIVE = "is-active";
	var CLASS_PREV = "is-prev";
	var CLASS_NEXT = "is-next";
	var CLASS_VISIBLE = "is-visible";
	var CLASS_LOADING = "is-loading";
	var CLASS_FOCUS_IN = "is-focus-in";
	var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN];
	var CLASSES = {
	  slide: CLASS_SLIDE,
	  clone: CLASS_CLONE,
	  arrows: CLASS_ARROWS,
	  arrow: CLASS_ARROW,
	  prev: CLASS_ARROW_PREV,
	  next: CLASS_ARROW_NEXT,
	  pagination: CLASS_PAGINATION,
	  page: CLASS_PAGINATION_PAGE,
	  spinner: CLASS_SPINNER
	};
	
	function closest(from, selector) {
	  if (isFunction(from.closest)) {
	    return from.closest(selector);
	  }
	
	  var elm = from;
	
	  while (elm && elm.nodeType === 1) {
	    if (matches(elm, selector)) {
	      break;
	    }
	
	    elm = elm.parentElement;
	  }
	
	  return elm;
	}
	
	var FRICTION = 5;
	var LOG_INTERVAL = 200;
	var POINTER_DOWN_EVENTS = "touchstart mousedown";
	var POINTER_MOVE_EVENTS = "touchmove mousemove";
	var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
	
	function Elements(Splide2, Components2, options) {
	  var _EventInterface = EventInterface(Splide2),
	      on = _EventInterface.on,
	      bind = _EventInterface.bind;
	
	  var root = Splide2.root;
	  var i18n = options.i18n;
	  var elements = {};
	  var slides = [];
	  var rootClasses = [];
	  var trackClasses = [];
	  var track;
	  var list;
	  var isUsingKey;
	
	  function setup() {
	    collect();
	    init();
	    update();
	  }
	
	  function mount() {
	    on(EVENT_REFRESH, destroy);
	    on(EVENT_REFRESH, setup);
	    on(EVENT_UPDATED, update);
	    bind(document, POINTER_DOWN_EVENTS + " keydown", function (e) {
	      isUsingKey = e.type === "keydown";
	    }, {
	      capture: true
	    });
	    bind(root, "focusin", function () {
	      toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
	    });
	  }
	
	  function destroy(completely) {
	    var attrs = ALL_ATTRIBUTES.concat("style");
	    empty(slides);
	    removeClass(root, rootClasses);
	    removeClass(track, trackClasses);
	    removeAttribute([track, list], attrs);
	    removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
	  }
	
	  function update() {
	    removeClass(root, rootClasses);
	    removeClass(track, trackClasses);
	    rootClasses = getClasses(CLASS_ROOT);
	    trackClasses = getClasses(CLASS_TRACK);
	    addClass(root, rootClasses);
	    addClass(track, trackClasses);
	    setAttribute(root, ARIA_LABEL, options.label);
	    setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
	  }
	
	  function collect() {
	    track = find("." + CLASS_TRACK);
	    list = child(track, "." + CLASS_LIST);
	    assert(track && list, "A track/list element is missing.");
	    push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
	    forOwn({
	      arrows: CLASS_ARROWS,
	      pagination: CLASS_PAGINATION,
	      prev: CLASS_ARROW_PREV,
	      next: CLASS_ARROW_NEXT,
	      bar: CLASS_PROGRESS_BAR,
	      toggle: CLASS_TOGGLE
	    }, function (className, key) {
	      elements[key] = find("." + className);
	    });
	    assign(elements, {
	      root: root,
	      track: track,
	      list: list,
	      slides: slides
	    });
	  }
	
	  function init() {
	    var id = root.id || uniqueId(PROJECT_CODE);
	    var role = options.role;
	    root.id = id;
	    track.id = track.id || id + "-track";
	    list.id = list.id || id + "-list";
	
	    if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
	      setAttribute(root, ROLE, role);
	    }
	
	    setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
	    setAttribute(list, ROLE, "presentation");
	  }
	
	  function find(selector) {
	    var elm = query(root, selector);
	    return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
	  }
	
	  function getClasses(base) {
	    return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
	  }
	
	  return assign(elements, {
	    setup: setup,
	    mount: mount,
	    destroy: destroy
	  });
	}
	
	var SLIDE = "slide";
	var LOOP = "loop";
	var FADE = "fade";
	
	function Slide$1(Splide2, index, slideIndex, slide) {
	  var event = EventInterface(Splide2);
	  var on = event.on,
	      emit = event.emit,
	      bind = event.bind;
	  var Components = Splide2.Components,
	      root = Splide2.root,
	      options = Splide2.options;
	  var isNavigation = options.isNavigation,
	      updateOnMove = options.updateOnMove,
	      i18n = options.i18n,
	      pagination = options.pagination,
	      slideFocus = options.slideFocus;
	  var resolve = Components.Direction.resolve;
	  var styles = getAttribute(slide, "style");
	  var label = getAttribute(slide, ARIA_LABEL);
	  var isClone = slideIndex > -1;
	  var container = child(slide, "." + CLASS_CONTAINER);
	  var focusableNodes = queryAll(slide, options.focusableNodes || "");
	  var destroyed;
	
	  function mount() {
	    if (!isClone) {
	      slide.id = root.id + "-slide" + pad(index + 1);
	      setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
	      setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
	      setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
	    }
	
	    listen();
	  }
	
	  function listen() {
	    bind(slide, "click", apply(emit, EVENT_CLICK, self));
	    bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self));
	    on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
	    on(EVENT_NAVIGATION_MOUNTED, initNavigation);
	
	    if (updateOnMove) {
	      on(EVENT_MOVE, onMove);
	    }
	  }
	
	  function destroy() {
	    destroyed = true;
	    event.destroy();
	    removeClass(slide, STATUS_CLASSES);
	    removeAttribute(slide, ALL_ATTRIBUTES);
	    setAttribute(slide, "style", styles);
	    setAttribute(slide, ARIA_LABEL, label || "");
	  }
	
	  function initNavigation() {
	    var controls = Splide2.splides.map(function (target) {
	      var Slide2 = target.splide.Components.Slides.getAt(index);
	      return Slide2 ? Slide2.slide.id : "";
	    }).join(" ");
	    setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
	    setAttribute(slide, ARIA_CONTROLS, controls);
	    setAttribute(slide, ROLE, slideFocus ? "button" : "");
	    slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
	  }
	
	  function onMove() {
	    if (!destroyed) {
	      update();
	    }
	  }
	
	  function update() {
	    if (!destroyed) {
	      var curr = Splide2.index;
	      updateActivity();
	      updateVisibility();
	      toggleClass(slide, CLASS_PREV, index === curr - 1);
	      toggleClass(slide, CLASS_NEXT, index === curr + 1);
	    }
	  }
	
	  function updateActivity() {
	    var active = isActive();
	
	    if (active !== hasClass(slide, CLASS_ACTIVE)) {
	      toggleClass(slide, CLASS_ACTIVE, active);
	      setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
	      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
	    }
	  }
	
	  function updateVisibility() {
	    var visible = isVisible();
	    var hidden = !visible && (!isActive() || isClone);
	
	    if (!Splide2.state.is([MOVING, SCROLLING])) {
	      setAttribute(slide, ARIA_HIDDEN, hidden || "");
	    }
	
	    setAttribute(focusableNodes, TAB_INDEX, hidden ? -1 : "");
	
	    if (slideFocus) {
	      setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
	    }
	
	    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
	      toggleClass(slide, CLASS_VISIBLE, visible);
	      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
	    }
	
	    if (!visible && document.activeElement === slide) {
	      var Slide2 = Components.Slides.getAt(Splide2.index);
	      Slide2 && focus(Slide2.slide);
	    }
	  }
	
	  function style$1(prop, value, useContainer) {
	    style(useContainer && container || slide, prop, value);
	  }
	
	  function isActive() {
	    var curr = Splide2.index;
	    return curr === index || options.cloneStatus && curr === slideIndex;
	  }
	
	  function isVisible() {
	    if (Splide2.is(FADE)) {
	      return isActive();
	    }
	
	    var trackRect = rect(Components.Elements.track);
	    var slideRect = rect(slide);
	    var left = resolve("left", true);
	    var right = resolve("right", true);
	    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
	  }
	
	  function isWithin(from, distance) {
	    var diff = abs(from - index);
	
	    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
	      diff = min(diff, Splide2.length - diff);
	    }
	
	    return diff <= distance;
	  }
	
	  var self = {
	    index: index,
	    slideIndex: slideIndex,
	    slide: slide,
	    container: container,
	    isClone: isClone,
	    mount: mount,
	    destroy: destroy,
	    update: update,
	    style: style$1,
	    isWithin: isWithin
	  };
	  return self;
	}
	
	function Slides(Splide2, Components2, options) {
	  var _EventInterface2 = EventInterface(Splide2),
	      on = _EventInterface2.on,
	      emit = _EventInterface2.emit,
	      bind = _EventInterface2.bind;
	
	  var _Components2$Elements = Components2.Elements,
	      slides = _Components2$Elements.slides,
	      list = _Components2$Elements.list;
	  var Slides2 = [];
	
	  function mount() {
	    init();
	    on(EVENT_REFRESH, destroy);
	    on(EVENT_REFRESH, init);
	    on([EVENT_MOUNTED, EVENT_REFRESH], function () {
	      Slides2.sort(function (Slide1, Slide2) {
	        return Slide1.index - Slide2.index;
	      });
	    });
	  }
	
	  function init() {
	    slides.forEach(function (slide, index) {
	      register(slide, index, -1);
	    });
	  }
	
	  function destroy() {
	    forEach$1(function (Slide2) {
	      Slide2.destroy();
	    });
	    empty(Slides2);
	  }
	
	  function update() {
	    forEach$1(function (Slide2) {
	      Slide2.update();
	    });
	  }
	
	  function register(slide, index, slideIndex) {
	    var object = Slide$1(Splide2, index, slideIndex, slide);
	    object.mount();
	    Slides2.push(object);
	  }
	
	  function get(excludeClones) {
	    return excludeClones ? filter(function (Slide2) {
	      return !Slide2.isClone;
	    }) : Slides2;
	  }
	
	  function getIn(page) {
	    var Controller = Components2.Controller;
	    var index = Controller.toIndex(page);
	    var max = Controller.hasFocus() ? 1 : options.perPage;
	    return filter(function (Slide2) {
	      return between(Slide2.index, index, index + max - 1);
	    });
	  }
	
	  function getAt(index) {
	    return filter(index)[0];
	  }
	
	  function add(items, index) {
	    forEach(items, function (slide) {
	      if (isString(slide)) {
	        slide = parseHtml(slide);
	      }
	
	      if (isHTMLElement(slide)) {
	        var ref = slides[index];
	        ref ? before(slide, ref) : append(list, slide);
	        addClass(slide, options.classes.slide);
	        observeImages(slide, apply(emit, EVENT_RESIZE));
	      }
	    });
	    emit(EVENT_REFRESH);
	  }
	
	  function remove$1(matcher) {
	    remove(filter(matcher).map(function (Slide2) {
	      return Slide2.slide;
	    }));
	    emit(EVENT_REFRESH);
	  }
	
	  function forEach$1(iteratee, excludeClones) {
	    get(excludeClones).forEach(iteratee);
	  }
	
	  function filter(matcher) {
	    return Slides2.filter(isFunction(matcher) ? matcher : function (Slide2) {
	      return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
	    });
	  }
	
	  function style(prop, value, useContainer) {
	    forEach$1(function (Slide2) {
	      Slide2.style(prop, value, useContainer);
	    });
	  }
	
	  function observeImages(elm, callback) {
	    var images = queryAll(elm, "img");
	    var length = images.length;
	
	    if (length) {
	      images.forEach(function (img) {
	        bind(img, "load error", function () {
	          if (! --length) {
	            callback();
	          }
	        });
	      });
	    } else {
	      callback();
	    }
	  }
	
	  function getLength(excludeClones) {
	    return excludeClones ? slides.length : Slides2.length;
	  }
	
	  function isEnough() {
	    return Slides2.length > options.perPage;
	  }
	
	  return {
	    mount: mount,
	    destroy: destroy,
	    update: update,
	    register: register,
	    get: get,
	    getIn: getIn,
	    getAt: getAt,
	    add: add,
	    remove: remove$1,
	    forEach: forEach$1,
	    filter: filter,
	    style: style,
	    getLength: getLength,
	    isEnough: isEnough
	  };
	}
	
	function Layout(Splide2, Components2, options) {
	  var _EventInterface3 = EventInterface(Splide2),
	      on = _EventInterface3.on,
	      bind = _EventInterface3.bind,
	      emit = _EventInterface3.emit;
	
	  var Slides = Components2.Slides;
	  var resolve = Components2.Direction.resolve;
	  var _Components2$Elements2 = Components2.Elements,
	      root = _Components2$Elements2.root,
	      track = _Components2$Elements2.track,
	      list = _Components2$Elements2.list;
	  var getAt = Slides.getAt,
	      styleSlides = Slides.style;
	  var vertical;
	  var rootRect;
	
	  function mount() {
	    init();
	    bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
	    on([EVENT_UPDATED, EVENT_REFRESH], init);
	    on(EVENT_RESIZE, resize);
	  }
	
	  function init() {
	    rootRect = null;
	    vertical = options.direction === TTB;
	    style(root, "maxWidth", unit(options.width));
	    style(track, resolve("paddingLeft"), cssPadding(false));
	    style(track, resolve("paddingRight"), cssPadding(true));
	    resize();
	  }
	
	  function resize() {
	    var newRect = rect(root);
	
	    if (!rootRect || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
	      style(track, "height", cssTrackHeight());
	      styleSlides(resolve("marginRight"), unit(options.gap));
	      styleSlides("width", cssSlideWidth());
	      styleSlides("height", cssSlideHeight(), true);
	      rootRect = newRect;
	      emit(EVENT_RESIZED);
	    }
	  }
	
	  function cssPadding(right) {
	    var padding = options.padding;
	    var prop = resolve(right ? "right" : "left");
	    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
	  }
	
	  function cssTrackHeight() {
	    var height = "";
	
	    if (vertical) {
	      height = cssHeight();
	      assert(height, "height or heightRatio is missing.");
	      height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
	    }
	
	    return height;
	  }
	
	  function cssHeight() {
	    return unit(options.height || rect(list).width * options.heightRatio);
	  }
	
	  function cssSlideWidth() {
	    return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
	  }
	
	  function cssSlideHeight() {
	    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
	  }
	
	  function cssSlideSize() {
	    var gap = unit(options.gap);
	    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
	  }
	
	  function listSize() {
	    return rect(list)[resolve("width")];
	  }
	
	  function slideSize(index, withoutGap) {
	    var Slide = getAt(index || 0);
	    return Slide ? rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
	  }
	
	  function totalSize(index, withoutGap) {
	    var Slide = getAt(index);
	
	    if (Slide) {
	      var right = rect(Slide.slide)[resolve("right")];
	      var left = rect(list)[resolve("left")];
	      return abs(right - left) + (withoutGap ? 0 : getGap());
	    }
	
	    return 0;
	  }
	
	  function sliderSize() {
	    return totalSize(Splide2.length - 1, true) - totalSize(-1, true);
	  }
	
	  function getGap() {
	    var Slide = getAt(0);
	    return Slide && parseFloat(style(Slide.slide, resolve("marginRight"))) || 0;
	  }
	
	  function getPadding(right) {
	    return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
	  }
	
	  return {
	    mount: mount,
	    listSize: listSize,
	    slideSize: slideSize,
	    sliderSize: sliderSize,
	    totalSize: totalSize,
	    getPadding: getPadding
	  };
	}
	
	var MULTIPLIER = 2;
	
	function Clones(Splide2, Components2, options) {
	  var _EventInterface4 = EventInterface(Splide2),
	      on = _EventInterface4.on,
	      emit = _EventInterface4.emit;
	
	  var Elements = Components2.Elements,
	      Slides = Components2.Slides;
	  var resolve = Components2.Direction.resolve;
	  var clones = [];
	  var cloneCount;
	
	  function mount() {
	    init();
	    on(EVENT_REFRESH, destroy);
	    on(EVENT_REFRESH, init);
	    on([EVENT_UPDATED, EVENT_RESIZE], observe);
	  }
	
	  function init() {
	    if (cloneCount = computeCloneCount()) {
	      generate(cloneCount);
	      emit(EVENT_RESIZE);
	    }
	  }
	
	  function destroy() {
	    remove(clones);
	    empty(clones);
	  }
	
	  function observe() {
	    if (cloneCount < computeCloneCount()) {
	      emit(EVENT_REFRESH);
	    }
	  }
	
	  function generate(count) {
	    var slides = Slides.get().slice();
	    var length = slides.length;
	
	    if (length) {
	      while (slides.length < count) {
	        push(slides, slides);
	      }
	
	      push(slides.slice(-count), slides.slice(0, count)).forEach(function (Slide, index) {
	        var isHead = index < count;
	        var clone = cloneDeep(Slide.slide, index);
	        isHead ? before(clone, slides[0].slide) : append(Elements.list, clone);
	        push(clones, clone);
	        Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
	      });
	    }
	  }
	
	  function cloneDeep(elm, index) {
	    var clone = elm.cloneNode(true);
	    addClass(clone, options.classes.clone);
	    clone.id = Splide2.root.id + "-clone" + pad(index + 1);
	    return clone;
	  }
	
	  function computeCloneCount() {
	    var clones2 = options.clones;
	
	    if (!Splide2.is(LOOP)) {
	      clones2 = 0;
	    } else if (!clones2) {
	      var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
	      var fixedCount = fixedSize && ceil(rect(Elements.track)[resolve("width")] / fixedSize);
	      clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
	    }
	
	    return clones2;
	  }
	
	  return {
	    mount: mount,
	    destroy: destroy
	  };
	}
	
	function Move(Splide2, Components2, options) {
	  var _EventInterface5 = EventInterface(Splide2),
	      on = _EventInterface5.on,
	      emit = _EventInterface5.emit;
	
	  var set = Splide2.state.set;
	  var _Components2$Layout = Components2.Layout,
	      slideSize = _Components2$Layout.slideSize,
	      getPadding = _Components2$Layout.getPadding,
	      totalSize = _Components2$Layout.totalSize,
	      listSize = _Components2$Layout.listSize,
	      sliderSize = _Components2$Layout.sliderSize;
	  var _Components2$Directio = Components2.Direction,
	      resolve = _Components2$Directio.resolve,
	      orient = _Components2$Directio.orient;
	  var _Components2$Elements3 = Components2.Elements,
	      list = _Components2$Elements3.list,
	      track = _Components2$Elements3.track;
	  var Transition;
	
	  function mount() {
	    Transition = Components2.Transition;
	    on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
	  }
	
	  function reposition() {
	    if (!Components2.Controller.isBusy()) {
	      Components2.Scroll.cancel();
	      jump(Splide2.index);
	      Components2.Slides.update();
	    }
	  }
	
	  function move(dest, index, prev, callback) {
	    if (dest !== index && canShift(dest > prev)) {
	      cancel();
	      translate(shift(getPosition(), dest > prev), true);
	    }
	
	    set(MOVING);
	    emit(EVENT_MOVE, index, prev, dest);
	    Transition.start(index, function () {
	      set(IDLE);
	      emit(EVENT_MOVED, index, prev, dest);
	      callback && callback();
	    });
	  }
	
	  function jump(index) {
	    translate(toPosition(index, true));
	  }
	
	  function translate(position, preventLoop) {
	    if (!Splide2.is(FADE)) {
	      var destination = preventLoop ? position : loop(position);
	      style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
	      position !== destination && emit(EVENT_SHIFTED);
	    }
	  }
	
	  function loop(position) {
	    if (Splide2.is(LOOP)) {
	      var index = toIndex(position);
	      var exceededMax = index > Components2.Controller.getEnd();
	      var exceededMin = index < 0;
	
	      if (exceededMin || exceededMax) {
	        position = shift(position, exceededMax);
	      }
	    }
	
	    return position;
	  }
	
	  function shift(position, backwards) {
	    var excess = position - getLimit(backwards);
	    var size = sliderSize();
	    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
	    return position;
	  }
	
	  function cancel() {
	    translate(getPosition());
	    Transition.cancel();
	  }
	
	  function toIndex(position) {
	    var Slides = Components2.Slides.get();
	    var index = 0;
	    var minDistance = Infinity;
	
	    for (var i = 0; i < Slides.length; i++) {
	      var slideIndex = Slides[i].index;
	      var distance = abs(toPosition(slideIndex, true) - position);
	
	      if (distance <= minDistance) {
	        minDistance = distance;
	        index = slideIndex;
	      } else {
	        break;
	      }
	    }
	
	    return index;
	  }
	
	  function toPosition(index, trimming) {
	    var position = orient(totalSize(index - 1) - offset(index));
	    return trimming ? trim(position) : position;
	  }
	
	  function getPosition() {
	    var left = resolve("left");
	    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
	  }
	
	  function trim(position) {
	    if (options.trimSpace && Splide2.is(SLIDE)) {
	      position = clamp(position, 0, orient(sliderSize() - listSize()));
	    }
	
	    return position;
	  }
	
	  function offset(index) {
	    var focus = options.focus;
	    return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
	  }
	
	  function getLimit(max) {
	    return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
	  }
	
	  function canShift(backwards) {
	    var shifted = orient(shift(getPosition(), backwards));
	    return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
	  }
	
	  function exceededLimit(max, position) {
	    position = isUndefined(position) ? getPosition() : position;
	    var exceededMin = max !== true && orient(position) < orient(getLimit(false));
	    var exceededMax = max !== false && orient(position) > orient(getLimit(true));
	    return exceededMin || exceededMax;
	  }
	
	  return {
	    mount: mount,
	    move: move,
	    jump: jump,
	    translate: translate,
	    shift: shift,
	    cancel: cancel,
	    toIndex: toIndex,
	    toPosition: toPosition,
	    getPosition: getPosition,
	    getLimit: getLimit,
	    exceededLimit: exceededLimit,
	    reposition: reposition
	  };
	}
	
	function Controller(Splide2, Components2, options) {
	  var _EventInterface6 = EventInterface(Splide2),
	      on = _EventInterface6.on;
	
	  var Move = Components2.Move;
	  var getPosition = Move.getPosition,
	      getLimit = Move.getLimit,
	      toPosition = Move.toPosition;
	  var _Components2$Slides = Components2.Slides,
	      isEnough = _Components2$Slides.isEnough,
	      getLength = _Components2$Slides.getLength;
	  var isLoop = Splide2.is(LOOP);
	  var isSlide = Splide2.is(SLIDE);
	  var getNext = apply(getAdjacent, false);
	  var getPrev = apply(getAdjacent, true);
	  var currIndex = options.start || 0;
	  var prevIndex = currIndex;
	  var slideCount;
	  var perMove;
	  var perPage;
	
	  function mount() {
	    init();
	    on([EVENT_UPDATED, EVENT_REFRESH], init);
	  }
	
	  function init() {
	    slideCount = getLength(true);
	    perMove = options.perMove;
	    perPage = options.perPage;
	    var index = clamp(currIndex, 0, slideCount - 1);
	
	    if (index !== currIndex) {
	      currIndex = index;
	      Move.reposition();
	    }
	  }
	
	  function go(control, allowSameIndex, callback) {
	    if (!isBusy()) {
	      var dest = parse(control);
	      var index = loop(dest);
	
	      if (index > -1 && (allowSameIndex || index !== currIndex)) {
	        setIndex(index);
	        Move.move(dest, index, prevIndex, callback);
	      }
	    }
	  }
	
	  function scroll(destination, duration, snap, callback) {
	    Components2.Scroll.scroll(destination, duration, snap, function () {
	      setIndex(loop(Move.toIndex(getPosition())));
	      callback && callback();
	    });
	  }
	
	  function parse(control) {
	    var index = currIndex;
	
	    if (isString(control)) {
	      var _ref = control.match(/([+\-<>])(\d+)?/) || [],
	          indicator = _ref[1],
	          number = _ref[2];
	
	      if (indicator === "+" || indicator === "-") {
	        index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
	      } else if (indicator === ">") {
	        index = number ? toIndex(+number) : getNext(true);
	      } else if (indicator === "<") {
	        index = getPrev(true);
	      }
	    } else {
	      index = isLoop ? control : clamp(control, 0, getEnd());
	    }
	
	    return index;
	  }
	
	  function getAdjacent(prev, destination) {
	    var number = perMove || (hasFocus() ? 1 : perPage);
	    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
	
	    if (dest === -1 && isSlide) {
	      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
	        return prev ? 0 : getEnd();
	      }
	    }
	
	    return destination ? dest : loop(dest);
	  }
	
	  function computeDestIndex(dest, from, snapPage) {
	    if (isEnough()) {
	      var end = getEnd();
	      var index = computeMovableDestIndex(dest);
	
	      if (index !== dest) {
	        from = dest;
	        dest = index;
	        snapPage = false;
	      }
	
	      if (dest < 0 || dest > end) {
	        if (!perMove && (between(0, dest, from, true) || between(end, from, dest, true))) {
	          dest = toIndex(toPage(dest));
	        } else {
	          if (isLoop) {
	            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
	          } else if (options.rewind) {
	            dest = dest < 0 ? end : 0;
	          } else {
	            dest = -1;
	          }
	        }
	      } else {
	        if (snapPage && dest !== from) {
	          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
	        }
	      }
	    } else {
	      dest = -1;
	    }
	
	    return dest;
	  }
	
	  function computeMovableDestIndex(dest) {
	    if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
	      var position = getPosition();
	
	      while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
	        dest < currIndex ? --dest : ++dest;
	      }
	    }
	
	    return dest;
	  }
	
	  function loop(index) {
	    return isLoop ? (index + slideCount) % slideCount || 0 : index;
	  }
	
	  function getEnd() {
	    return max(slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage), 0);
	  }
	
	  function toIndex(page) {
	    return clamp(hasFocus() ? page : perPage * page, 0, getEnd());
	  }
	
	  function toPage(index) {
	    return hasFocus() ? index : floor((index >= getEnd() ? slideCount - 1 : index) / perPage);
	  }
	
	  function toDest(destination) {
	    var closest = Move.toIndex(destination);
	    return isSlide ? clamp(closest, 0, getEnd()) : closest;
	  }
	
	  function setIndex(index) {
	    if (index !== currIndex) {
	      prevIndex = currIndex;
	      currIndex = index;
	    }
	  }
	
	  function getIndex(prev) {
	    return prev ? prevIndex : currIndex;
	  }
	
	  function hasFocus() {
	    return !isUndefined(options.focus) || options.isNavigation;
	  }
	
	  function isBusy() {
	    return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
	  }
	
	  return {
	    mount: mount,
	    go: go,
	    scroll: scroll,
	    getNext: getNext,
	    getPrev: getPrev,
	    getAdjacent: getAdjacent,
	    getEnd: getEnd,
	    setIndex: setIndex,
	    getIndex: getIndex,
	    toIndex: toIndex,
	    toPage: toPage,
	    toDest: toDest,
	    hasFocus: hasFocus,
	    isBusy: isBusy
	  };
	}
	
	var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
	var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
	var SIZE = 40;
	
	function Arrows(Splide2, Components2, options) {
	  var event = EventInterface(Splide2);
	  var on = event.on,
	      bind = event.bind,
	      emit = event.emit;
	  var classes = options.classes,
	      i18n = options.i18n;
	  var Elements = Components2.Elements,
	      Controller = Components2.Controller;
	  var userArrows = Elements.arrows,
	      track = Elements.track;
	  var wrapper = userArrows;
	  var prev = Elements.prev;
	  var next = Elements.next;
	  var created;
	  var wrapperClasses;
	  var arrows = {};
	
	  function mount() {
	    init();
	    on(EVENT_UPDATED, remount);
	  }
	
	  function remount() {
	    destroy();
	    mount();
	  }
	
	  function init() {
	    var enabled = options.arrows;
	
	    if (enabled && !(prev && next)) {
	      createArrows();
	    }
	
	    if (prev && next) {
	      assign(arrows, {
	        prev: prev,
	        next: next
	      });
	      display(wrapper, enabled ? "" : "none");
	      addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
	
	      if (enabled) {
	        listen();
	        update();
	        setAttribute([prev, next], ARIA_CONTROLS, track.id);
	        emit(EVENT_ARROWS_MOUNTED, prev, next);
	      }
	    }
	  }
	
	  function destroy() {
	    event.destroy();
	    removeClass(wrapper, wrapperClasses);
	
	    if (created) {
	      remove(userArrows ? [prev, next] : wrapper);
	      prev = next = null;
	    } else {
	      removeAttribute([prev, next], ALL_ATTRIBUTES);
	    }
	  }
	
	  function listen() {
	    on([EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED], update);
	    bind(next, "click", apply(go, ">"));
	    bind(prev, "click", apply(go, "<"));
	  }
	
	  function go(control) {
	    Controller.go(control, true);
	  }
	
	  function createArrows() {
	    wrapper = userArrows || create("div", classes.arrows);
	    prev = createArrow(true);
	    next = createArrow(false);
	    created = true;
	    append(wrapper, [prev, next]);
	    !userArrows && before(wrapper, track);
	  }
	
	  function createArrow(prev2) {
	    var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + XML_NAME_SPACE + "\" viewBox=\"0 0 " + SIZE + " " + SIZE + "\" width=\"" + SIZE + "\" height=\"" + SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || PATH) + "\" />";
	    return parseHtml(arrow);
	  }
	
	  function update() {
	    var index = Splide2.index;
	    var prevIndex = Controller.getPrev();
	    var nextIndex = Controller.getNext();
	    var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
	    var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
	    prev.disabled = prevIndex < 0;
	    next.disabled = nextIndex < 0;
	    setAttribute(prev, ARIA_LABEL, prevLabel);
	    setAttribute(next, ARIA_LABEL, nextLabel);
	    emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
	  }
	
	  return {
	    arrows: arrows,
	    mount: mount,
	    destroy: destroy
	  };
	}
	
	var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
	
	function Autoplay(Splide2, Components2, options) {
	  var _EventInterface7 = EventInterface(Splide2),
	      on = _EventInterface7.on,
	      bind = _EventInterface7.bind,
	      emit = _EventInterface7.emit;
	
	  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
	  var isPaused = interval.isPaused;
	  var Elements = Components2.Elements,
	      _Components2$Elements4 = Components2.Elements,
	      root = _Components2$Elements4.root,
	      toggle = _Components2$Elements4.toggle;
	  var autoplay = options.autoplay;
	  var hovered;
	  var focused;
	  var stopped = autoplay === "pause";
	
	  function mount() {
	    if (autoplay) {
	      listen();
	      toggle && setAttribute(toggle, ARIA_CONTROLS, Elements.track.id);
	      stopped || play();
	      update();
	    }
	  }
	
	  function listen() {
	    if (options.pauseOnHover) {
	      bind(root, "mouseenter mouseleave", function (e) {
	        hovered = e.type === "mouseenter";
	        autoToggle();
	      });
	    }
	
	    if (options.pauseOnFocus) {
	      bind(root, "focusin focusout", function (e) {
	        focused = e.type === "focusin";
	        autoToggle();
	      });
	    }
	
	    if (toggle) {
	      bind(toggle, "click", function () {
	        stopped ? play() : pause(true);
	      });
	    }
	
	    on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
	    on(EVENT_MOVE, onMove);
	  }
	
	  function play() {
	    if (isPaused() && Components2.Slides.isEnough()) {
	      interval.start(!options.resetProgress);
	      focused = hovered = stopped = false;
	      update();
	      emit(EVENT_AUTOPLAY_PLAY);
	    }
	  }
	
	  function pause(stop) {
	    if (stop === void 0) {
	      stop = true;
	    }
	
	    stopped = !!stop;
	    update();
	
	    if (!isPaused()) {
	      interval.pause();
	      emit(EVENT_AUTOPLAY_PAUSE);
	    }
	  }
	
	  function autoToggle() {
	    if (!stopped) {
	      hovered || focused ? pause(false) : play();
	    }
	  }
	
	  function update() {
	    if (toggle) {
	      toggleClass(toggle, CLASS_ACTIVE, !stopped);
	      setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
	    }
	  }
	
	  function onAnimationFrame(rate) {
	    var bar = Elements.bar;
	    bar && style(bar, "width", rate * 100 + "%");
	    emit(EVENT_AUTOPLAY_PLAYING, rate);
	  }
	
	  function onMove(index) {
	    var Slide = Components2.Slides.getAt(index);
	    interval.set(Slide && +getAttribute(Slide.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
	  }
	
	  return {
	    mount: mount,
	    destroy: interval.cancel,
	    play: play,
	    pause: pause,
	    isPaused: isPaused
	  };
	}
	
	function Cover(Splide2, Components2, options) {
	  var _EventInterface8 = EventInterface(Splide2),
	      on = _EventInterface8.on;
	
	  function mount() {
	    if (options.cover) {
	      on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
	      on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
	    }
	  }
	
	  function cover(cover2) {
	    Components2.Slides.forEach(function (Slide) {
	      var img = child(Slide.container || Slide.slide, "img");
	
	      if (img && img.src) {
	        toggle(cover2, img, Slide);
	      }
	    });
	  }
	
	  function toggle(cover2, img, Slide) {
	    Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
	    display(img, cover2 ? "none" : "");
	  }
	
	  return {
	    mount: mount,
	    destroy: apply(cover, false)
	  };
	}
	
	var BOUNCE_DIFF_THRESHOLD = 10;
	var BOUNCE_DURATION = 600;
	var FRICTION_FACTOR = 0.6;
	var BASE_VELOCITY = 1.5;
	var MIN_DURATION = 800;
	
	function Scroll(Splide2, Components2, options) {
	  var _EventInterface9 = EventInterface(Splide2),
	      on = _EventInterface9.on,
	      emit = _EventInterface9.emit;
	
	  var set = Splide2.state.set;
	  var Move = Components2.Move;
	  var getPosition = Move.getPosition,
	      getLimit = Move.getLimit,
	      exceededLimit = Move.exceededLimit,
	      translate = Move.translate;
	  var interval;
	  var callback;
	  var friction = 1;
	
	  function mount() {
	    on(EVENT_MOVE, clear);
	    on([EVENT_UPDATED, EVENT_REFRESH], cancel);
	  }
	
	  function scroll(destination, duration, snap, onScrolled, noConstrain) {
	    var from = getPosition();
	    clear();
	
	    if (snap) {
	      var size = Components2.Layout.sliderSize();
	      var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
	      destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
	    }
	
	    var noDistance = approximatelyEqual(from, destination, 1);
	    friction = 1;
	    duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
	    callback = onScrolled;
	    interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
	    set(SCROLLING);
	    emit(EVENT_SCROLL);
	    interval.start();
	  }
	
	  function onEnd() {
	    set(IDLE);
	    callback && callback();
	    emit(EVENT_SCROLLED);
	  }
	
	  function update(from, to, noConstrain, rate) {
	    var position = getPosition();
	    var target = from + (to - from) * easing(rate);
	    var diff = (target - position) * friction;
	    translate(position + diff);
	
	    if (Splide2.is(SLIDE) && !noConstrain && exceededLimit()) {
	      friction *= FRICTION_FACTOR;
	
	      if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
	        scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
	      }
	    }
	  }
	
	  function clear() {
	    if (interval) {
	      interval.cancel();
	    }
	  }
	
	  function cancel() {
	    if (interval && !interval.isPaused()) {
	      clear();
	      onEnd();
	    }
	  }
	
	  function easing(t) {
	    var easingFunc = options.easingFunc;
	    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
	  }
	
	  return {
	    mount: mount,
	    destroy: clear,
	    scroll: scroll,
	    cancel: cancel
	  };
	}
	
	var SCROLL_LISTENER_OPTIONS = {
	  passive: false,
	  capture: true
	};
	
	function Drag(Splide2, Components2, options) {
	  var _EventInterface10 = EventInterface(Splide2),
	      on = _EventInterface10.on,
	      emit = _EventInterface10.emit,
	      bind = _EventInterface10.bind,
	      unbind = _EventInterface10.unbind;
	
	  var state = Splide2.state;
	  var Move = Components2.Move,
	      Scroll = Components2.Scroll,
	      Controller = Components2.Controller,
	      track = Components2.Elements.track,
	      reduce = Components2.Media.reduce;
	  var _Components2$Directio2 = Components2.Direction,
	      resolve = _Components2$Directio2.resolve,
	      orient = _Components2$Directio2.orient;
	  var getPosition = Move.getPosition,
	      exceededLimit = Move.exceededLimit;
	  var basePosition;
	  var baseEvent;
	  var prevBaseEvent;
	  var isFree;
	  var dragging;
	  var exceeded = false;
	  var clickPrevented;
	  var disabled;
	  var target;
	
	  function mount() {
	    bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
	    bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
	    bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
	    bind(track, "click", onClick, {
	      capture: true
	    });
	    bind(track, "dragstart", prevent);
	    on([EVENT_MOUNTED, EVENT_UPDATED], init);
	  }
	
	  function init() {
	    var drag = options.drag;
	    disable(!drag);
	    isFree = drag === "free";
	  }
	
	  function onPointerDown(e) {
	    clickPrevented = false;
	
	    if (!disabled) {
	      var isTouch = isTouchEvent(e);
	
	      if (isDraggable(e.target) && (isTouch || !e.button)) {
	        if (!Controller.isBusy()) {
	          target = isTouch ? track : window;
	          dragging = state.is([MOVING, SCROLLING]);
	          prevBaseEvent = null;
	          bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
	          bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
	          Move.cancel();
	          Scroll.cancel();
	          save(e);
	        } else {
	          prevent(e, true);
	        }
	      }
	    }
	  }
	
	  function onPointerMove(e) {
	    if (!state.is(DRAGGING)) {
	      state.set(DRAGGING);
	      emit(EVENT_DRAG);
	    }
	
	    if (e.cancelable) {
	      if (dragging) {
	        Move.translate(basePosition + constrain(diffCoord(e)));
	        var expired = diffTime(e) > LOG_INTERVAL;
	        var hasExceeded = exceeded !== (exceeded = exceededLimit());
	
	        if (expired || hasExceeded) {
	          save(e);
	        }
	
	        clickPrevented = true;
	        emit(EVENT_DRAGGING);
	        prevent(e);
	      } else if (isSliderDirection(e)) {
	        dragging = shouldStart(e);
	        prevent(e);
	      }
	    }
	  }
	
	  function onPointerUp(e) {
	    if (state.is(DRAGGING)) {
	      state.set(IDLE);
	      emit(EVENT_DRAGGED);
	    }
	
	    if (dragging) {
	      move(e);
	      prevent(e);
	    }
	
	    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
	    unbind(target, POINTER_UP_EVENTS, onPointerUp);
	    dragging = false;
	  }
	
	  function onClick(e) {
	    if (!disabled && clickPrevented) {
	      prevent(e, true);
	    }
	  }
	
	  function save(e) {
	    prevBaseEvent = baseEvent;
	    baseEvent = e;
	    basePosition = getPosition();
	  }
	
	  function move(e) {
	    var velocity = computeVelocity(e);
	    var destination = computeDestination(velocity);
	    var rewind = options.rewind && options.rewindByDrag;
	    reduce(false);
	
	    if (isFree) {
	      Controller.scroll(destination, 0, options.snap);
	    } else if (Splide2.is(FADE)) {
	      Controller.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
	    } else if (Splide2.is(SLIDE) && exceeded && rewind) {
	      Controller.go(exceededLimit(true) ? ">" : "<");
	    } else {
	      Controller.go(Controller.toDest(destination), true);
	    }
	
	    reduce(true);
	  }
	
	  function shouldStart(e) {
	    var thresholds = options.dragMinThreshold;
	    var isObj = isObject(thresholds);
	    var mouse = isObj && thresholds.mouse || 0;
	    var touch = (isObj ? thresholds.touch : +thresholds) || 10;
	    return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
	  }
	
	  function isSliderDirection(e) {
	    return abs(diffCoord(e)) > abs(diffCoord(e, true));
	  }
	
	  function computeVelocity(e) {
	    if (Splide2.is(LOOP) || !exceeded) {
	      var time = diffTime(e);
	
	      if (time && time < LOG_INTERVAL) {
	        return diffCoord(e) / time;
	      }
	    }
	
	    return 0;
	  }
	
	  function computeDestination(velocity) {
	    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
	  }
	
	  function diffCoord(e, orthogonal) {
	    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
	  }
	
	  function diffTime(e) {
	    return timeOf(e) - timeOf(getBaseEvent(e));
	  }
	
	  function getBaseEvent(e) {
	    return baseEvent === e && prevBaseEvent || baseEvent;
	  }
	
	  function coordOf(e, orthogonal) {
	    return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
	  }
	
	  function constrain(diff) {
	    return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
	  }
	
	  function isDraggable(target2) {
	    var noDrag = options.noDrag;
	    return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
	  }
	
	  function isTouchEvent(e) {
	    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
	  }
	
	  function isDragging() {
	    return dragging;
	  }
	
	  function disable(value) {
	    disabled = value;
	  }
	
	  return {
	    mount: mount,
	    disable: disable,
	    isDragging: isDragging
	  };
	}
	
	var NORMALIZATION_MAP = {
	  Spacebar: " ",
	  Right: ARROW_RIGHT,
	  Left: ARROW_LEFT,
	  Up: ARROW_UP,
	  Down: ARROW_DOWN
	};
	
	function normalizeKey(key) {
	  key = isString(key) ? key : key.key;
	  return NORMALIZATION_MAP[key] || key;
	}
	
	var KEYBOARD_EVENT = "keydown";
	
	function Keyboard(Splide2, Components2, options) {
	  var _EventInterface11 = EventInterface(Splide2),
	      on = _EventInterface11.on,
	      bind = _EventInterface11.bind,
	      unbind = _EventInterface11.unbind;
	
	  var root = Splide2.root;
	  var resolve = Components2.Direction.resolve;
	  var target;
	  var disabled;
	
	  function mount() {
	    init();
	    on(EVENT_UPDATED, destroy);
	    on(EVENT_UPDATED, init);
	    on(EVENT_MOVE, onMove);
	  }
	
	  function init() {
	    var keyboard = options.keyboard;
	
	    if (keyboard) {
	      target = keyboard === "global" ? window : root;
	      bind(target, KEYBOARD_EVENT, onKeydown);
	    }
	  }
	
	  function destroy() {
	    unbind(target, KEYBOARD_EVENT);
	  }
	
	  function disable(value) {
	    disabled = value;
	  }
	
	  function onMove() {
	    var _disabled = disabled;
	    disabled = true;
	    nextTick(function () {
	      disabled = _disabled;
	    });
	  }
	
	  function onKeydown(e) {
	    if (!disabled) {
	      var key = normalizeKey(e);
	
	      if (key === resolve(ARROW_LEFT)) {
	        Splide2.go("<");
	      } else if (key === resolve(ARROW_RIGHT)) {
	        Splide2.go(">");
	      }
	    }
	  }
	
	  return {
	    mount: mount,
	    destroy: destroy,
	    disable: disable
	  };
	}
	
	var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
	var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
	var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
	
	function LazyLoad(Splide2, Components2, options) {
	  var _EventInterface12 = EventInterface(Splide2),
	      on = _EventInterface12.on,
	      off = _EventInterface12.off,
	      bind = _EventInterface12.bind,
	      emit = _EventInterface12.emit;
	
	  var isSequential = options.lazyLoad === "sequential";
	  var events = [EVENT_MOUNTED, EVENT_REFRESH, EVENT_MOVED, EVENT_SCROLLED];
	  var entries = [];
	
	  function mount() {
	    if (options.lazyLoad) {
	      init();
	      on(EVENT_REFRESH, init);
	      isSequential || on(events, observe);
	    }
	  }
	
	  function init() {
	    empty(entries);
	    Components2.Slides.forEach(function (Slide) {
	      queryAll(Slide.slide, IMAGE_SELECTOR).forEach(function (img) {
	        var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
	        var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
	
	        if (src !== img.src || srcset !== img.srcset) {
	          var className = options.classes.spinner;
	          var parent = img.parentElement;
	          var spinner = child(parent, "." + className) || create("span", className, parent);
	          entries.push([img, Slide, spinner]);
	          img.src || display(img, "none");
	        }
	      });
	    });
	    isSequential && loadNext();
	  }
	
	  function observe() {
	    entries = entries.filter(function (data) {
	      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
	      return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
	    });
	    entries.length || off(events);
	  }
	
	  function load(data) {
	    var img = data[0];
	    addClass(data[1].slide, CLASS_LOADING);
	    bind(img, "load error", apply(onLoad, data));
	    setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
	    setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
	    removeAttribute(img, SRC_DATA_ATTRIBUTE);
	    removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
	  }
	
	  function onLoad(data, e) {
	    var img = data[0],
	        Slide = data[1];
	    removeClass(Slide.slide, CLASS_LOADING);
	
	    if (e.type !== "error") {
	      remove(data[2]);
	      display(img, "");
	      emit(EVENT_LAZYLOAD_LOADED, img, Slide);
	      emit(EVENT_RESIZE);
	    }
	
	    isSequential && loadNext();
	  }
	
	  function loadNext() {
	    entries.length && load(entries.shift());
	  }
	
	  return {
	    mount: mount,
	    destroy: apply(empty, entries)
	  };
	}
	
	function Pagination(Splide2, Components2, options) {
	  var event = EventInterface(Splide2);
	  var on = event.on,
	      emit = event.emit,
	      bind = event.bind;
	  var Slides = Components2.Slides,
	      Elements = Components2.Elements,
	      Controller = Components2.Controller;
	  var hasFocus = Controller.hasFocus,
	      getIndex = Controller.getIndex,
	      go = Controller.go;
	  var resolve = Components2.Direction.resolve;
	  var items = [];
	  var list;
	  var paginationClasses;
	
	  function mount() {
	    destroy();
	    on([EVENT_UPDATED, EVENT_REFRESH], mount);
	
	    if (options.pagination && Slides.isEnough()) {
	      on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
	      createPagination();
	      update();
	      emit(EVENT_PAGINATION_MOUNTED, {
	        list: list,
	        items: items
	      }, getAt(Splide2.index));
	    }
	  }
	
	  function destroy() {
	    if (list) {
	      remove(Elements.pagination ? slice(list.children) : list);
	      removeClass(list, paginationClasses);
	      empty(items);
	      list = null;
	    }
	
	    event.destroy();
	  }
	
	  function createPagination() {
	    var length = Splide2.length;
	    var classes = options.classes,
	        i18n = options.i18n,
	        perPage = options.perPage;
	    var max = hasFocus() ? length : ceil(length / perPage);
	    list = Elements.pagination || create("ul", classes.pagination, Elements.track.parentElement);
	    addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
	    setAttribute(list, ROLE, "tablist");
	    setAttribute(list, ARIA_LABEL, i18n.select);
	    setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
	
	    for (var i = 0; i < max; i++) {
	      var li = create("li", null, list);
	      var button = create("button", {
	        class: classes.page,
	        type: "button"
	      }, li);
	      var controls = Slides.getIn(i).map(function (Slide) {
	        return Slide.slide.id;
	      });
	      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
	      bind(button, "click", apply(onClick, i));
	
	      if (options.paginationKeyboard) {
	        bind(button, "keydown", apply(onKeydown, i));
	      }
	
	      setAttribute(li, ROLE, "presentation");
	      setAttribute(button, ROLE, "tab");
	      setAttribute(button, ARIA_CONTROLS, controls.join(" "));
	      setAttribute(button, ARIA_LABEL, format(text, i + 1));
	      setAttribute(button, TAB_INDEX, -1);
	      items.push({
	        li: li,
	        button: button,
	        page: i
	      });
	    }
	  }
	
	  function onClick(page) {
	    go(">" + page, true);
	  }
	
	  function onKeydown(page, e) {
	    var length = items.length;
	    var key = normalizeKey(e);
	    var dir = getDirection();
	    var nextPage = -1;
	
	    if (key === resolve(ARROW_RIGHT, false, dir)) {
	      nextPage = ++page % length;
	    } else if (key === resolve(ARROW_LEFT, false, dir)) {
	      nextPage = (--page + length) % length;
	    } else if (key === "Home") {
	      nextPage = 0;
	    } else if (key === "End") {
	      nextPage = length - 1;
	    }
	
	    var item = items[nextPage];
	
	    if (item) {
	      focus(item.button);
	      go(">" + nextPage);
	      prevent(e, true);
	    }
	  }
	
	  function getDirection() {
	    return options.paginationDirection || options.direction;
	  }
	
	  function getAt(index) {
	    return items[Controller.toPage(index)];
	  }
	
	  function update() {
	    var prev = getAt(getIndex(true));
	    var curr = getAt(getIndex());
	
	    if (prev) {
	      var button = prev.button;
	      removeClass(button, CLASS_ACTIVE);
	      removeAttribute(button, ARIA_SELECTED);
	      setAttribute(button, TAB_INDEX, -1);
	    }
	
	    if (curr) {
	      var _button = curr.button;
	      addClass(_button, CLASS_ACTIVE);
	      setAttribute(_button, ARIA_SELECTED, true);
	      setAttribute(_button, TAB_INDEX, "");
	    }
	
	    emit(EVENT_PAGINATION_UPDATED, {
	      list: list,
	      items: items
	    }, prev, curr);
	  }
	
	  return {
	    items: items,
	    mount: mount,
	    destroy: destroy,
	    getAt: getAt,
	    update: update
	  };
	}
	
	var TRIGGER_KEYS = [" ", "Enter"];
	
	function Sync(Splide2, Components2, options) {
	  var isNavigation = options.isNavigation,
	      slideFocus = options.slideFocus;
	  var events = [];
	
	  function setup() {
	    Splide2.options = {
	      slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
	    };
	  }
	
	  function mount() {
	    Splide2.splides.forEach(function (target) {
	      if (!target.isParent) {
	        sync(Splide2, target.splide);
	        sync(target.splide, Splide2);
	      }
	    });
	
	    if (isNavigation) {
	      navigate();
	    }
	  }
	
	  function destroy() {
	    events.forEach(function (event) {
	      event.destroy();
	    });
	    empty(events);
	  }
	
	  function remount() {
	    destroy();
	    mount();
	  }
	
	  function sync(splide, target) {
	    var event = EventInterface(splide);
	    event.on(EVENT_MOVE, function (index, prev, dest) {
	      target.go(target.is(LOOP) ? dest : index);
	    });
	    events.push(event);
	  }
	
	  function navigate() {
	    var event = EventInterface(Splide2);
	    var on = event.on;
	    on(EVENT_CLICK, onClick);
	    on(EVENT_SLIDE_KEYDOWN, onKeydown);
	    on([EVENT_MOUNTED, EVENT_UPDATED], update);
	    events.push(event);
	    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
	  }
	
	  function update() {
	    setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
	  }
	
	  function onClick(Slide) {
	    Splide2.go(Slide.index);
	  }
	
	  function onKeydown(Slide, e) {
	    if (includes(TRIGGER_KEYS, normalizeKey(e))) {
	      onClick(Slide);
	      prevent(e);
	    }
	  }
	
	  return {
	    setup: setup,
	    mount: mount,
	    destroy: destroy,
	    remount: remount
	  };
	}
	
	function Wheel(Splide2, Components2, options) {
	  var _EventInterface13 = EventInterface(Splide2),
	      bind = _EventInterface13.bind;
	
	  var lastTime = 0;
	
	  function mount() {
	    if (options.wheel) {
	      bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
	    }
	  }
	
	  function onWheel(e) {
	    if (e.cancelable) {
	      var deltaY = e.deltaY;
	      var backwards = deltaY < 0;
	      var timeStamp = timeOf(e);
	
	      var _min = options.wheelMinThreshold || 0;
	
	      var sleep = options.wheelSleep || 0;
	
	      if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
	        Splide2.go(backwards ? "<" : ">");
	        lastTime = timeStamp;
	      }
	
	      shouldPrevent(backwards) && prevent(e);
	    }
	  }
	
	  function shouldPrevent(backwards) {
	    return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
	  }
	
	  return {
	    mount: mount
	  };
	}
	
	var SR_REMOVAL_DELAY = 90;
	
	function Live(Splide2, Components2, options) {
	  var _EventInterface14 = EventInterface(Splide2),
	      on = _EventInterface14.on;
	
	  var track = Components2.Elements.track;
	  var enabled = options.live && !options.isNavigation;
	  var sr = create("span", CLASS_SR);
	  var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
	
	  function mount() {
	    if (enabled) {
	      disable(!Components2.Autoplay.isPaused());
	      setAttribute(track, ARIA_ATOMIC, true);
	      sr.textContent = "\u2026";
	      on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
	      on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
	      on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
	    }
	  }
	
	  function toggle(active) {
	    setAttribute(track, ARIA_BUSY, active);
	
	    if (active) {
	      append(track, sr);
	      interval.start();
	    } else {
	      remove(sr);
	    }
	  }
	
	  function destroy() {
	    removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
	    remove(sr);
	  }
	
	  function disable(disabled) {
	    if (enabled) {
	      setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
	    }
	  }
	
	  return {
	    mount: mount,
	    disable: disable,
	    destroy: destroy
	  };
	}
	
	var ComponentConstructors = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  Media: Media,
	  Direction: Direction,
	  Elements: Elements,
	  Slides: Slides,
	  Layout: Layout,
	  Clones: Clones,
	  Move: Move,
	  Controller: Controller,
	  Arrows: Arrows,
	  Autoplay: Autoplay,
	  Cover: Cover,
	  Scroll: Scroll,
	  Drag: Drag,
	  Keyboard: Keyboard,
	  LazyLoad: LazyLoad,
	  Pagination: Pagination,
	  Sync: Sync,
	  Wheel: Wheel,
	  Live: Live
	});
	var I18N = {
	  prev: "Previous slide",
	  next: "Next slide",
	  first: "Go to first slide",
	  last: "Go to last slide",
	  slideX: "Go to slide %s",
	  pageX: "Go to page %s",
	  play: "Start autoplay",
	  pause: "Pause autoplay",
	  carousel: "carousel",
	  slide: "slide",
	  select: "Select a slide to show",
	  slideLabel: "%s of %s"
	};
	var DEFAULTS = {
	  type: "slide",
	  role: "region",
	  speed: 400,
	  perPage: 1,
	  cloneStatus: true,
	  arrows: true,
	  pagination: true,
	  paginationKeyboard: true,
	  interval: 5e3,
	  pauseOnHover: true,
	  pauseOnFocus: true,
	  resetProgress: true,
	  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
	  drag: true,
	  direction: "ltr",
	  trimSpace: true,
	  focusableNodes: "a, button, textarea, input, select, iframe",
	  live: true,
	  classes: CLASSES,
	  i18n: I18N,
	  reducedMotion: {
	    speed: 0,
	    rewindSpeed: 0,
	    autoplay: "pause"
	  }
	};
	
	function Fade(Splide2, Components2, options) {
	  var _EventInterface15 = EventInterface(Splide2),
	      on = _EventInterface15.on;
	
	  function mount() {
	    on([EVENT_MOUNTED, EVENT_REFRESH], function () {
	      nextTick(function () {
	        Components2.Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
	      });
	    });
	  }
	
	  function start(index, done) {
	    var track = Components2.Elements.track;
	    style(track, "height", unit(rect(track).height));
	    nextTick(function () {
	      done();
	      style(track, "height", "");
	    });
	  }
	
	  return {
	    mount: mount,
	    start: start,
	    cancel: noop
	  };
	}
	
	function Slide(Splide2, Components2, options) {
	  var _EventInterface16 = EventInterface(Splide2),
	      bind = _EventInterface16.bind;
	
	  var Move = Components2.Move,
	      Controller = Components2.Controller,
	      Scroll = Components2.Scroll;
	  var list = Components2.Elements.list;
	  var transition = apply(style, list, "transition");
	  var endCallback;
	
	  function mount() {
	    bind(list, "transitionend", function (e) {
	      if (e.target === list && endCallback) {
	        cancel();
	        endCallback();
	      }
	    });
	  }
	
	  function start(index, done) {
	    var destination = Move.toPosition(index, true);
	    var position = Move.getPosition();
	    var speed = getSpeed(index);
	
	    if (abs(destination - position) >= 1 && speed >= 1) {
	      if (options.useScroll) {
	        Scroll.scroll(destination, speed, false, done);
	      } else {
	        transition("transform " + speed + "ms " + options.easing);
	        Move.translate(destination, true);
	        endCallback = done;
	      }
	    } else {
	      Move.jump(index);
	      done();
	    }
	  }
	
	  function cancel() {
	    transition("");
	    Scroll.cancel();
	  }
	
	  function getSpeed(index) {
	    var rewindSpeed = options.rewindSpeed;
	
	    if (Splide2.is(SLIDE) && rewindSpeed) {
	      var prev = Controller.getIndex(true);
	      var end = Controller.getEnd();
	
	      if (prev === 0 && index >= end || prev >= end && index === 0) {
	        return rewindSpeed;
	      }
	    }
	
	    return options.speed;
	  }
	
	  return {
	    mount: mount,
	    start: start,
	    cancel: cancel
	  };
	}
	
	var _Splide = /*#__PURE__*/function () {
	  function _Splide(target, options) {
	    this.event = EventInterface();
	    this.Components = {};
	    this.state = State(CREATED);
	    this.splides = [];
	    this._o = {};
	    this._E = {};
	    var root = isString(target) ? query(document, target) : target;
	    assert(root, root + " is invalid.");
	    this.root = root;
	    options = merge({
	      label: getAttribute(root, ARIA_LABEL) || "",
	      labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
	    }, DEFAULTS, _Splide.defaults, options || {});
	
	    try {
	      merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
	    } catch (e) {
	      assert(false, "Invalid JSON");
	    }
	
	    this._o = Object.create(merge({}, options));
	  }
	
	  var _proto = _Splide.prototype;
	
	  _proto.mount = function mount(Extensions, Transition) {
	    var _this = this;
	
	    var state = this.state,
	        Components2 = this.Components;
	    assert(state.is([CREATED, DESTROYED]), "Already mounted!");
	    state.set(CREATED);
	    this._C = Components2;
	    this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
	    this._E = Extensions || this._E;
	    var Constructors = assign({}, ComponentConstructors, this._E, {
	      Transition: this._T
	    });
	    forOwn(Constructors, function (Component, key) {
	      var component = Component(_this, Components2, _this._o);
	      Components2[key] = component;
	      component.setup && component.setup();
	    });
	    forOwn(Components2, function (component) {
	      component.mount && component.mount();
	    });
	    this.emit(EVENT_MOUNTED);
	    addClass(this.root, CLASS_INITIALIZED);
	    state.set(IDLE);
	    this.emit(EVENT_READY);
	    return this;
	  };
	
	  _proto.sync = function sync(splide) {
	    this.splides.push({
	      splide: splide
	    });
	    splide.splides.push({
	      splide: this,
	      isParent: true
	    });
	
	    if (this.state.is(IDLE)) {
	      this._C.Sync.remount();
	
	      splide.Components.Sync.remount();
	    }
	
	    return this;
	  };
	
	  _proto.go = function go(control) {
	    this._C.Controller.go(control);
	
	    return this;
	  };
	
	  _proto.on = function on(events, callback) {
	    this.event.on(events, callback);
	    return this;
	  };
	
	  _proto.off = function off(events) {
	    this.event.off(events);
	    return this;
	  };
	
	  _proto.emit = function emit(event) {
	    var _this$event;
	
	    (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
	
	    return this;
	  };
	
	  _proto.add = function add(slides, index) {
	    this._C.Slides.add(slides, index);
	
	    return this;
	  };
	
	  _proto.remove = function remove(matcher) {
	    this._C.Slides.remove(matcher);
	
	    return this;
	  };
	
	  _proto.is = function is(type) {
	    return this._o.type === type;
	  };
	
	  _proto.refresh = function refresh() {
	    this.emit(EVENT_REFRESH);
	    return this;
	  };
	
	  _proto.destroy = function destroy(completely) {
	    if (completely === void 0) {
	      completely = true;
	    }
	
	    var event = this.event,
	        state = this.state;
	
	    if (state.is(CREATED)) {
	      EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
	    } else {
	      forOwn(this._C, function (component) {
	        component.destroy && component.destroy(completely);
	      }, true);
	      event.emit(EVENT_DESTROY);
	      event.destroy();
	      completely && empty(this.splides);
	      state.set(DESTROYED);
	    }
	
	    return this;
	  };
	
	  _createClass(_Splide, [{
	    key: "options",
	    get: function get() {
	      return this._o;
	    },
	    set: function set(options) {
	      this._C.Media.set(options, true);
	    }
	  }, {
	    key: "length",
	    get: function get() {
	      return this._C.Slides.getLength(true);
	    }
	  }, {
	    key: "index",
	    get: function get() {
	      return this._C.Controller.getIndex();
	    }
	  }]);
	
	  return _Splide;
	}();
	
	var Splide = _Splide;
	Splide.defaults = {};
	Splide.STATES = STATES;
	var CLASS_RENDERED = "is-rendered";
	var RENDERER_DEFAULT_CONFIG = {
	  listTag: "ul",
	  slideTag: "li"
	};
	
	var Style = /*#__PURE__*/function () {
	  function Style(id, options) {
	    this.styles = {};
	    this.id = id;
	    this.options = options;
	  }
	
	  var _proto2 = Style.prototype;
	
	  _proto2.rule = function rule(selector, prop, value, breakpoint) {
	    breakpoint = breakpoint || "default";
	    var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
	    var styles = selectors[selector] = selectors[selector] || {};
	    styles[prop] = value;
	  };
	
	  _proto2.build = function build() {
	    var _this2 = this;
	
	    var css = "";
	
	    if (this.styles.default) {
	      css += this.buildSelectors(this.styles.default);
	    }
	
	    Object.keys(this.styles).sort(function (n, m) {
	      return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
	    }).forEach(function (breakpoint) {
	      if (breakpoint !== "default") {
	        css += "@media screen and (max-width: " + breakpoint + "px) {";
	        css += _this2.buildSelectors(_this2.styles[breakpoint]);
	        css += "}";
	      }
	    });
	    return css;
	  };
	
	  _proto2.buildSelectors = function buildSelectors(selectors) {
	    var _this3 = this;
	
	    var css = "";
	    forOwn(selectors, function (styles, selector) {
	      selector = ("#" + _this3.id + " " + selector).trim();
	      css += selector + " {";
	      forOwn(styles, function (value, prop) {
	        if (value || value === 0) {
	          css += prop + ": " + value + ";";
	        }
	      });
	      css += "}";
	    });
	    return css;
	  };
	
	  return Style;
	}();
	
	var SplideRenderer = /*#__PURE__*/function () {
	  function SplideRenderer(contents, options, config, defaults) {
	    this.slides = [];
	    this.options = {};
	    this.breakpoints = [];
	    merge(DEFAULTS, defaults || {});
	    merge(merge(this.options, DEFAULTS), options || {});
	    this.contents = contents;
	    this.config = assign({}, RENDERER_DEFAULT_CONFIG, config || {});
	    this.id = this.config.id || uniqueId("splide");
	    this.Style = new Style(this.id, this.options);
	    this.Direction = Direction(null, null, this.options);
	    assert(this.contents.length, "Provide at least 1 content.");
	    this.init();
	  }
	
	  SplideRenderer.clean = function clean(splide) {
	    var _EventInterface17 = EventInterface(splide),
	        on = _EventInterface17.on;
	
	    var root = splide.root;
	    var clones = queryAll(root, "." + CLASS_CLONE);
	    on(EVENT_MOUNTED, function () {
	      remove(child(root, "style"));
	    });
	    remove(clones);
	  };
	
	  var _proto3 = SplideRenderer.prototype;
	
	  _proto3.init = function init() {
	    this.parseBreakpoints();
	    this.initSlides();
	    this.registerRootStyles();
	    this.registerTrackStyles();
	    this.registerSlideStyles();
	    this.registerListStyles();
	  };
	
	  _proto3.initSlides = function initSlides() {
	    var _this4 = this;
	
	    push(this.slides, this.contents.map(function (content, index) {
	      content = isString(content) ? {
	        html: content
	      } : content;
	      content.styles = content.styles || {};
	      content.attrs = content.attrs || {};
	
	      _this4.cover(content);
	
	      var classes = _this4.options.classes.slide + " " + (index === 0 ? CLASS_ACTIVE : "");
	      assign(content.attrs, {
	        class: (classes + " " + (content.attrs.class || "")).trim(),
	        style: _this4.buildStyles(content.styles)
	      });
	      return content;
	    }));
	
	    if (this.isLoop()) {
	      this.generateClones(this.slides);
	    }
	  };
	
	  _proto3.registerRootStyles = function registerRootStyles() {
	    var _this5 = this;
	
	    this.breakpoints.forEach(function (_ref2) {
	      var width = _ref2[0],
	          options = _ref2[1];
	
	      _this5.Style.rule(" ", "max-width", unit(options.width), width);
	    });
	  };
	
	  _proto3.registerTrackStyles = function registerTrackStyles() {
	    var _this6 = this;
	
	    var Style2 = this.Style;
	    var selector = "." + CLASS_TRACK;
	    this.breakpoints.forEach(function (_ref3) {
	      var width = _ref3[0],
	          options = _ref3[1];
	      Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
	      Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
	      Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
	    });
	  };
	
	  _proto3.registerListStyles = function registerListStyles() {
	    var _this7 = this;
	
	    var Style2 = this.Style;
	    var selector = "." + CLASS_LIST;
	    this.breakpoints.forEach(function (_ref4) {
	      var width = _ref4[0],
	          options = _ref4[1];
	      Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
	
	      if (!_this7.cssSlideHeight(options)) {
	        Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
	      }
	    });
	  };
	
	  _proto3.registerSlideStyles = function registerSlideStyles() {
	    var _this8 = this;
	
	    var Style2 = this.Style;
	    var selector = "." + CLASS_SLIDE;
	    this.breakpoints.forEach(function (_ref5) {
	      var width = _ref5[0],
	          options = _ref5[1];
	      Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
	      Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
	      Style2.rule(selector, _this8.resolve("marginRight"), unit(options.gap) || "0px", width);
	      Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
	    });
	  };
	
	  _proto3.buildTranslate = function buildTranslate(options) {
	    var _this$Direction = this.Direction,
	        resolve = _this$Direction.resolve,
	        orient = _this$Direction.orient;
	    var values = [];
	    values.push(this.cssOffsetClones(options));
	    values.push(this.cssOffsetGaps(options));
	
	    if (this.isCenter(options)) {
	      values.push(this.buildCssValue(orient(-50), "%"));
	      values.push.apply(values, this.cssOffsetCenter(options));
	    }
	
	    return values.filter(Boolean).map(function (value) {
	      return "translate" + resolve("X") + "(" + value + ")";
	    }).join(" ");
	  };
	
	  _proto3.cssOffsetClones = function cssOffsetClones(options) {
	    var _this$Direction2 = this.Direction,
	        resolve = _this$Direction2.resolve,
	        orient = _this$Direction2.orient;
	    var cloneCount = this.getCloneCount();
	
	    if (this.isFixedWidth(options)) {
	      var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]),
	          value = _this$parseCssValue.value,
	          unit2 = _this$parseCssValue.unit;
	
	      return this.buildCssValue(orient(value) * cloneCount, unit2);
	    }
	
	    var percent = 100 * cloneCount / options.perPage;
	    return orient(percent) + "%";
	  };
	
	  _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
	    var _this$Direction3 = this.Direction,
	        resolve = _this$Direction3.resolve,
	        orient = _this$Direction3.orient;
	
	    if (this.isFixedWidth(options)) {
	      var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]),
	          value = _this$parseCssValue2.value,
	          unit2 = _this$parseCssValue2.unit;
	
	      return [this.buildCssValue(orient(value / 2), unit2)];
	    }
	
	    var values = [];
	    var perPage = options.perPage,
	        gap = options.gap;
	    values.push(orient(50 / perPage) + "%");
	
	    if (gap) {
	      var _this$parseCssValue3 = this.parseCssValue(gap),
	          _value = _this$parseCssValue3.value,
	          _unit = _this$parseCssValue3.unit;
	
	      var gapOffset = (_value / perPage - _value) / 2;
	      values.push(this.buildCssValue(orient(gapOffset), _unit));
	    }
	
	    return values;
	  };
	
	  _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
	    var cloneCount = this.getCloneCount();
	
	    if (cloneCount && options.gap) {
	      var orient = this.Direction.orient;
	
	      var _this$parseCssValue4 = this.parseCssValue(options.gap),
	          value = _this$parseCssValue4.value,
	          unit2 = _this$parseCssValue4.unit;
	
	      if (this.isFixedWidth(options)) {
	        return this.buildCssValue(orient(value * cloneCount), unit2);
	      }
	
	      var perPage = options.perPage;
	      var gaps = cloneCount / perPage;
	      return this.buildCssValue(orient(gaps * value), unit2);
	    }
	
	    return "";
	  };
	
	  _proto3.resolve = function resolve(prop) {
	    return camelToKebab(this.Direction.resolve(prop));
	  };
	
	  _proto3.cssPadding = function cssPadding(options, right) {
	    var padding = options.padding;
	    var prop = this.Direction.resolve(right ? "right" : "left", true);
	    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
	  };
	
	  _proto3.cssTrackHeight = function cssTrackHeight(options) {
	    var height = "";
	
	    if (this.isVertical()) {
	      height = this.cssHeight(options);
	      assert(height, '"height" is missing.');
	      height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
	    }
	
	    return height;
	  };
	
	  _proto3.cssHeight = function cssHeight(options) {
	    return unit(options.height);
	  };
	
	  _proto3.cssSlideWidth = function cssSlideWidth(options) {
	    return options.autoWidth ? "" : unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
	  };
	
	  _proto3.cssSlideHeight = function cssSlideHeight(options) {
	    return unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
	  };
	
	  _proto3.cssSlideSize = function cssSlideSize(options) {
	    var gap = unit(options.gap);
	    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
	  };
	
	  _proto3.cssAspectRatio = function cssAspectRatio(options) {
	    var heightRatio = options.heightRatio;
	    return heightRatio ? "" + 1 / heightRatio : "";
	  };
	
	  _proto3.buildCssValue = function buildCssValue(value, unit2) {
	    return "" + value + unit2;
	  };
	
	  _proto3.parseCssValue = function parseCssValue(value) {
	    if (isString(value)) {
	      var number = parseFloat(value) || 0;
	      var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
	      return {
	        value: number,
	        unit: unit2
	      };
	    }
	
	    return {
	      value: value,
	      unit: "px"
	    };
	  };
	
	  _proto3.parseBreakpoints = function parseBreakpoints() {
	    var _this9 = this;
	
	    var breakpoints = this.options.breakpoints;
	    this.breakpoints.push(["default", this.options]);
	
	    if (breakpoints) {
	      forOwn(breakpoints, function (options, width) {
	        _this9.breakpoints.push([width, merge(merge({}, _this9.options), options)]);
	      });
	    }
	  };
	
	  _proto3.isFixedWidth = function isFixedWidth(options) {
	    return !!options[this.Direction.resolve("fixedWidth")];
	  };
	
	  _proto3.isLoop = function isLoop() {
	    return this.options.type === LOOP;
	  };
	
	  _proto3.isCenter = function isCenter(options) {
	    if (options.focus === "center") {
	      if (this.isLoop()) {
	        return true;
	      }
	
	      if (this.options.type === SLIDE) {
	        return !this.options.trimSpace;
	      }
	    }
	
	    return false;
	  };
	
	  _proto3.isVertical = function isVertical() {
	    return this.options.direction === TTB;
	  };
	
	  _proto3.buildClasses = function buildClasses() {
	    var options = this.options;
	    return [CLASS_ROOT, CLASS_ROOT + "--" + options.type, CLASS_ROOT + "--" + options.direction, options.drag && CLASS_ROOT + "--draggable", options.isNavigation && CLASS_ROOT + "--nav", CLASS_ACTIVE, !this.config.hidden && CLASS_RENDERED].filter(Boolean).join(" ");
	  };
	
	  _proto3.buildAttrs = function buildAttrs(attrs) {
	    var attr = "";
	    forOwn(attrs, function (value, key) {
	      attr += value ? " " + camelToKebab(key) + "=\"" + value + "\"" : "";
	    });
	    return attr.trim();
	  };
	
	  _proto3.buildStyles = function buildStyles(styles) {
	    var style = "";
	    forOwn(styles, function (value, key) {
	      style += " " + camelToKebab(key) + ":" + value + ";";
	    });
	    return style.trim();
	  };
	
	  _proto3.renderSlides = function renderSlides() {
	    var _this10 = this;
	
	    var tag = this.config.slideTag;
	    return this.slides.map(function (content) {
	      return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
	    }).join("");
	  };
	
	  _proto3.cover = function cover(content) {
	    var styles = content.styles,
	        _content$html = content.html,
	        html = _content$html === void 0 ? "" : _content$html;
	
	    if (this.options.cover && !this.options.lazyLoad) {
	      var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
	
	      if (src && src[2]) {
	        styles.background = "center/cover no-repeat url('" + src[2] + "')";
	      }
	    }
	  };
	
	  _proto3.generateClones = function generateClones(contents) {
	    var classes = this.options.classes;
	    var count = this.getCloneCount();
	    var slides = contents.slice();
	
	    while (slides.length < count) {
	      push(slides, slides);
	    }
	
	    push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function (content, index) {
	      var attrs = assign({}, content.attrs, {
	        class: content.attrs.class + " " + classes.clone
	      });
	      var clone = assign({}, content, {
	        attrs: attrs
	      });
	      index < count ? contents.unshift(clone) : contents.push(clone);
	    });
	  };
	
	  _proto3.getCloneCount = function getCloneCount() {
	    if (this.isLoop()) {
	      var options = this.options;
	
	      if (options.clones) {
	        return options.clones;
	      }
	
	      var perPage = max.apply(void 0, this.breakpoints.map(function (_ref6) {
	        var options2 = _ref6[1];
	        return options2.perPage;
	      }));
	      return perPage * ((options.flickMaxPages || 1) + 1);
	    }
	
	    return 0;
	  };
	
	  _proto3.renderArrows = function renderArrows() {
	    var html = "";
	    html += "<div class=\"" + this.options.classes.arrows + "\">";
	    html += this.renderArrow(true);
	    html += this.renderArrow(false);
	    html += "</div>";
	    return html;
	  };
	
	  _proto3.renderArrow = function renderArrow(prev) {
	    var _this$options = this.options,
	        classes = _this$options.classes,
	        i18n = _this$options.i18n;
	    var attrs = {
	      class: classes.arrow + " " + (prev ? classes.prev : classes.next),
	      type: "button",
	      ariaLabel: prev ? i18n.prev : i18n.next
	    };
	    return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + XML_NAME_SPACE + "\" viewBox=\"0 0 " + SIZE + " " + SIZE + "\" width=\"" + SIZE + "\" height=\"" + SIZE + "\"><path d=\"" + (this.options.arrowPath || PATH) + "\" /></svg></button>";
	  };
	
	  _proto3.html = function html() {
	    var _this$config = this.config,
	        rootClass = _this$config.rootClass,
	        listTag = _this$config.listTag,
	        arrows = _this$config.arrows,
	        beforeTrack = _this$config.beforeTrack,
	        afterTrack = _this$config.afterTrack,
	        slider = _this$config.slider,
	        beforeSlider = _this$config.beforeSlider,
	        afterSlider = _this$config.afterSlider;
	    var html = "";
	    html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
	    html += "<style>" + this.Style.build() + "</style>";
	
	    if (slider) {
	      html += beforeSlider || "";
	      html += "<div class=\"splide__slider\">";
	    }
	
	    html += beforeTrack || "";
	
	    if (arrows) {
	      html += this.renderArrows();
	    }
	
	    html += "<div class=\"splide__track\">";
	    html += "<" + listTag + " class=\"splide__list\">";
	    html += this.renderSlides();
	    html += "</" + listTag + ">";
	    html += "</div>";
	    html += afterTrack || "";
	
	    if (slider) {
	      html += "</div>";
	      html += afterSlider || "";
	    }
	
	    html += "</div>";
	    return html;
	  };
	
	  return SplideRenderer;
	}();
	
	exports.CLASSES = CLASSES;
	exports.CLASS_ACTIVE = CLASS_ACTIVE;
	exports.CLASS_ARROW = CLASS_ARROW;
	exports.CLASS_ARROWS = CLASS_ARROWS;
	exports.CLASS_ARROW_NEXT = CLASS_ARROW_NEXT;
	exports.CLASS_ARROW_PREV = CLASS_ARROW_PREV;
	exports.CLASS_CLONE = CLASS_CLONE;
	exports.CLASS_CONTAINER = CLASS_CONTAINER;
	exports.CLASS_FOCUS_IN = CLASS_FOCUS_IN;
	exports.CLASS_INITIALIZED = CLASS_INITIALIZED;
	exports.CLASS_LIST = CLASS_LIST;
	exports.CLASS_LOADING = CLASS_LOADING;
	exports.CLASS_NEXT = CLASS_NEXT;
	exports.CLASS_PAGINATION = CLASS_PAGINATION;
	exports.CLASS_PAGINATION_PAGE = CLASS_PAGINATION_PAGE;
	exports.CLASS_PREV = CLASS_PREV;
	exports.CLASS_PROGRESS = CLASS_PROGRESS;
	exports.CLASS_PROGRESS_BAR = CLASS_PROGRESS_BAR;
	exports.CLASS_ROOT = CLASS_ROOT;
	exports.CLASS_SLIDE = CLASS_SLIDE;
	exports.CLASS_SPINNER = CLASS_SPINNER;
	exports.CLASS_SR = CLASS_SR;
	exports.CLASS_TOGGLE = CLASS_TOGGLE;
	exports.CLASS_TOGGLE_PAUSE = CLASS_TOGGLE_PAUSE;
	exports.CLASS_TOGGLE_PLAY = CLASS_TOGGLE_PLAY;
	exports.CLASS_TRACK = CLASS_TRACK;
	exports.CLASS_VISIBLE = CLASS_VISIBLE;
	exports.DEFAULTS = DEFAULTS;
	exports.EVENT_ACTIVE = EVENT_ACTIVE;
	exports.EVENT_ARROWS_MOUNTED = EVENT_ARROWS_MOUNTED;
	exports.EVENT_ARROWS_UPDATED = EVENT_ARROWS_UPDATED;
	exports.EVENT_AUTOPLAY_PAUSE = EVENT_AUTOPLAY_PAUSE;
	exports.EVENT_AUTOPLAY_PLAY = EVENT_AUTOPLAY_PLAY;
	exports.EVENT_AUTOPLAY_PLAYING = EVENT_AUTOPLAY_PLAYING;
	exports.EVENT_CLICK = EVENT_CLICK;
	exports.EVENT_DESTROY = EVENT_DESTROY;
	exports.EVENT_DRAG = EVENT_DRAG;
	exports.EVENT_DRAGGED = EVENT_DRAGGED;
	exports.EVENT_DRAGGING = EVENT_DRAGGING;
	exports.EVENT_HIDDEN = EVENT_HIDDEN;
	exports.EVENT_INACTIVE = EVENT_INACTIVE;
	exports.EVENT_LAZYLOAD_LOADED = EVENT_LAZYLOAD_LOADED;
	exports.EVENT_MOUNTED = EVENT_MOUNTED;
	exports.EVENT_MOVE = EVENT_MOVE;
	exports.EVENT_MOVED = EVENT_MOVED;
	exports.EVENT_NAVIGATION_MOUNTED = EVENT_NAVIGATION_MOUNTED;
	exports.EVENT_PAGINATION_MOUNTED = EVENT_PAGINATION_MOUNTED;
	exports.EVENT_PAGINATION_UPDATED = EVENT_PAGINATION_UPDATED;
	exports.EVENT_READY = EVENT_READY;
	exports.EVENT_REFRESH = EVENT_REFRESH;
	exports.EVENT_RESIZE = EVENT_RESIZE;
	exports.EVENT_RESIZED = EVENT_RESIZED;
	exports.EVENT_SCROLL = EVENT_SCROLL;
	exports.EVENT_SCROLLED = EVENT_SCROLLED;
	exports.EVENT_SHIFTED = EVENT_SHIFTED;
	exports.EVENT_SLIDE_KEYDOWN = EVENT_SLIDE_KEYDOWN;
	exports.EVENT_UPDATED = EVENT_UPDATED;
	exports.EVENT_VISIBLE = EVENT_VISIBLE;
	exports.EventBinder = EventBinder;
	exports.EventInterface = EventInterface;
	exports.FADE = FADE;
	exports.LOOP = LOOP;
	exports.LTR = LTR;
	exports.RTL = RTL;
	exports.RequestInterval = RequestInterval;
	exports.SLIDE = SLIDE;
	exports.STATUS_CLASSES = STATUS_CLASSES;
	exports.Splide = Splide;
	exports.SplideRenderer = SplideRenderer;
	exports.State = State;
	exports.TTB = TTB;
	exports.Throttle = Throttle;
	exports["default"] = Splide;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js